// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/small-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/call.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/landing_page_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/sel_gray.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/login_left_panel_background1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.bg_img_height {
  height: 1500px;
  margin-top: -340px;
}

.paragraphs_font {
  font-family: "Sora", sans-serif;
}

.para_color {
  color: #93a2b3;
}

.link-text {
  color: #168de9;
}

.bg-dark-theme {
  background-color: #000b15;
}

input[type=file] {
  display: none;
}

.custom-file-upload {
  display: inline-block;
  cursor: pointer;
  color: wheat;
  background-color: #ff8a00;
}

.custom-csv-upload {
  display: inline-block;
  cursor: pointer;
  color: wheat;
  background: linear-gradient(90deg, rgb(16, 171, 254) 30%, rgb(0, 115, 238) 90%);
}

.language-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 92%;
  background-position-y: 15px;
}

.language-select-black-icon {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 8px;
}

.gradient_button {
  background: #0073ee;
}

.greetings {
  border-left: 2px solid;
  border-image: linear-gradient(to bottom, rgb(16, 171, 254), rgb(0, 115, 238)) 1 100%;
}

.text_gold {
  color: #e07900;
}

.button_gold {
  background-color: #e07900;
}

.select-box {
  height: 50px;
}

.gradient_text {
  background: linear-gradient(to right, #10abfe 1%, #0073ee 99%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lets_go_text {
  background: linear-gradient(to right, #10abfe 12%, #0073ee 40%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.opacity_blue {
  background-color: #111f2c;
}

.field_bg-blue {
  background-color: #000b15;
}

.inputfield {
  font-weight: 400;
  width: 100%;
  height: 58px;
  font-family: "inter", sans-serif;
  background-color: #000b15;
  border: 1px solid #1e293b;
  border-radius: 6px;
}

.was-validated {
  border: 1px solid red !important;
}

.was-validated::-webkit-input-placeholder {
  color: red;
}

.border {
  border: 1px solid #1e293b;
}

.button-border {
  border: 1px solid #1e293b;
}

.text-area {
  border: 1px solid #1e293b;
}

.PhoneInput {
  height: 45px;
  width: 100%;
  font-size: 16px;
  background-color: #000b15;
  border: 1px solid #1e293b;
}

.PhoneInputInput {
  height: 43px;
  width: 100%;
  background-color: #000b15 !important;
  outline: none;
  color: white;
}

.PhoneInputCountry {
  font-size: 18px;
  border-right: 1px solid #1e293b;
  padding-right: 10px;
  padding-left: 10px;
}

.PhoneInputCountryIconUnicode,
.PhoneInputCountryIcon {
  color: white;
}

.PhoneInputCountrySelectArrow {
  color: white;
}

.input_select {
  width: 70%;
  height: 30px;
}

input[type=date]::-webkit-calendar-picker-indicator {
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  width: 20px;
  height: 20px;
  border-width: thin;
  margin-top: 8px;
}

.landing-screen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  width: 100%;
  height: 702px;
  display: block;
  background-size: cover;
}

.dashboard_card_main {
  display: flex;
  height: 152px;
  border-radius: 2px;
  cursor: pointer;
  transition: 0.3s;
}

.dashboard_card_main:hover {
  transform: translate(0, -8px);
  box-shadow: 0 0 11px rgba(35, 87, 160, 0.7);
}

.dashboard_card_bg_color {
  color: white;
  background-color: #091724;
}

.dashboard_card_inner_right {
  padding: 0px 0px 0px 20px;
}

.card_title {
  font-size: 26px;
  font-weight: 700;
}

.card_description {
  font-size: 13px;
}

.user_registration_inner {
  display: flex;
}

.show {
  display: block;
}

.hide {
  display: none;
}

.left_bordered {
  height: 50px;
  border-left: 1px solid #1e293b;
  margin-left: 15px;
}

.tabs_right {
  padding-left: 30px;
}

.right-position {
  right: -760px;
}

.w-99 {
  width: 75%;
}

.w-200 {
  width: 500px;
  height: auto;
}

.animated {
  animation: rotate 550s normal linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  25% {
    transform: rotate3d(0, 0, 1, 90deg);
  }
  50% {
    transform: rotate3d(0, 0, 1, 180deg);
  }
  75% {
    transform: rotate3d(0, 0, 1, 270deg);
  }
  100% {
    transform: rotate3d(0, 0, 1, 360deg);
  }
}
.bg_color {
  background-color: #00080f;
}

.ant-table-wrapper .ant-pagination .ant-pagination-item {
  margin: 0 4px !important;
  background-color: transparent !important;
  font-family: "Sora", sans-serif;
}

.ant-table-wrapper .ant-pagination .ant-pagination-item-active {
  font-weight: bold !important;
  border: none !important;
  border-bottom: 2px solid #0073ee !important;
  border-radius: 0px;
  height: 46px;
  padding-top: 8px;
  background-color: transparent !important;
}

.ant-pagination-prev,
.ant-pagination-next {
  font-size: 14px !important;
  margin: 0 44px !important;
}

.dark-theme .ant-pagination-item-link,
.dark-theme .ant-pagination-prev,
.dark-theme .ant-pagination-next {
  background-color: #000b15 !important;
}

.light-theme .ant-pagination-item-link,
.light-theme .ant-pagination-prev,
.light-theme .ant-pagination-next {
  background-color: #fff !important;
}

.table_bg_color_black_th th {
  background-color: #000b15 !important;
  color: white !important;
  font-family: "Graphik", sans-serif !important;
  font-size: 16px !important;
  padding: 16.5px !important;
  line-height: 100% !important;
}

.table_bg_color_black_td td {
  background-color: #000b15 !important;
  color: white !important;
  font-family: "Sora", sans-serif !important;
  font-size: 16px !important;
  padding: 15.5px 16.5px !important;
  line-height: 100% !important;
}

.table_rows_black .ant-table-row > td {
  background-color: #091724 !important;
  background-color: #000b15 !important;
  border-top: 1px solid #1e293b;
  color: white !important;
}

.table_bg_color_white_th th {
  background-color: #ffffff !important;
  color: #1d242e !important;
  font-family: "Graphik", sans-serif !important;
  font-size: 16px !important;
  padding: 16.5px !important;
  line-height: 100% !important;
}

.table_bg_color_white_td td {
  background-color: #ffffff !important;
  color: #1d242e !important;
  font-family: "Sora", sans-serif !important;
  font-size: 16px !important;
  padding: 15.5px 16.5px !important;
  line-height: 100% !important;
}

.table_rows_white .ant-table-row > td {
  background-color: white !important;
  color: black !important;
  border-bottom: 1px solid black !important;
}

.table_rows_black .ant-table-placeholder > td {
  background-color: #091724 !important;
}

.table_rows_black .ant-table-placeholder > td .ant-empty-description {
  color: white !important;
}

.tabs_bg-white {
  background-color: #e3f2fe;
  color: #0073ee;
}

.bg-for-light {
  background-color: #fff;
}

.bg-import-button {
  background-color: #1e3a2c;
}

.bg-add-new-user-button {
  background-color: #5a4123;
}

.bg-add-new-company-button {
  background-color: #0c2541;
}

.bg-light-blue-button {
  background-color: #0073ee;
}

.bg-light-green-button {
  background-color: #20744a;
}

.modal-container-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 300;
}

.summary-container {
  background-color: rgba(0, 11, 21, 0.7);
}

.card-board {
  border: 1px solid #e5e9eb;
}

.border-right-only {
  border-right: 1px solid #e5e9eb;
}

.border-dashed {
  border: 1px dashed #e5e9eb;
}

.landign-screen-text-animated {
  background: linear-gradient(to right, rgb(16, 171, 254) 20%, rgb(0, 115, 238) 30%, rgb(16, 171, 254) 70%, rgb(0, 115, 238) 80%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 300% auto;
  animation: textShine 1s ease-in-out infinite alternate;
}

@keyframes textShine {
  0% {
    background-position: 0% 20%;
  }
  50% {
    background-position: 0% 40%;
  }
  100% {
    background-position: 100% 0%;
  }
}
.button-dark {
  background-color: #091724;
}

.input_field_main_password {
  position: relative;
}

.show_password {
  right: 10px;
}

input::-webkit-input-placeholder {
  color: #9e9e9e;
}

.box-shadow-sign-in {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
}

.input_field_main_textarea textarea {
  background: #000b15;
  border: 1px solid #1e293b;
  outline: none;
  color: white;
  resize: none;
}

.box_1 {
  width: 55px;
  height: 0px;
}

input[type=checkbox].switch_1 {
  font-size: 16px;
  appearance: none;
  width: 2.8em;
  height: 20px;
  background: #ddd;
  border-radius: 3em;
  position: relative;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease-in-out;
}

input[type=checkbox].switch_1:checked {
  background: #0ebeff;
}

input[type=checkbox].switch_1:after {
  position: absolute;
  content: "";
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
  transform: scale(0.7);
  left: -3px;
  top: -3.4px;
  transition: all 0.2s ease-in-out;
}

input[type=checkbox].switch_1:checked:after {
  left: calc(100% - 1.4em);
}

.checkBox_value_color {
  color: #e92f46;
}

.multi_select_field.ant-select-selector {
  outline: none;
  color: white;
  border: none !important;
  padding: 8px 0px !important;
  padding-left: 5px !important;
}

.multi_select_field.ant-select-arrow,
.multi_select_field.ant-select-clear {
  color: white !important;
}

.multi_select_field.ant-select-selection-item {
  background-color: #0073ee !important;
}

.multi_select_field.ant-select-selection-item-remove {
  color: white !important;
}

.multi_select_field.ant-select-selection-placeholder {
  color: #9e9e9e !important;
}

.w-35 {
  width: 35.666667%;
}

.w-49 {
  width: 49%;
}

::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(32, 32, 32);
  background: #01111f;
  /* border-radius: 10px; */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0073ee !important;
  /* border-radius: 10px; */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #0073ee;
}

/* Horizontal scrollbar */
::-webkit-scrollbar:horizontal {
  height: 7px;
  /* height of horizontal scrollbar */
}

/* Track for horizontal scrollbar */
::-webkit-scrollbar-track:horizontal {
  background: #01111f;
  /* color of the track for horizontal scrollbar */
}

/* Handle for horizontal scrollbar */
::-webkit-scrollbar-thumb:horizontal {
  background: #0073ee;
  /* color of the thumb for horizontal scrollbar */
}

/* Handle on hover for horizontal scrollbar */
::-webkit-scrollbar-thumb:horizontal:hover {
  background: #0056b3;
  /* color of the thumb on hover for horizontal scrollbar */
}

:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background: #0073ee;
}

.ant-table-wrapper.light-theme {
  border: 1px solid #e5e9eb !important;
  /* Border color for light theme */
  border-radius: 8px !important;
  /* Optional: Add border radius for rounded corners */
  overflow: hidden !important;
  /* Ensure content does not overflow the border */
}

/* Dark theme: Add border around the entire table */
.ant-table-wrapper.dark-theme {
  border: 1px solid #1e293b !important;
  /* Border color for dark theme */
  border-radius: 8px !important;
  /* Optional: Add border radius for rounded corners */
  overflow: hidden !important;
}

:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px !important;
}

/* .draggable-table .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container .ant-table-content .ant-table-thead .ant-table-cell{
  background: white!important;
} */
.ant-table-expanded-row .ant-table-cell {
  padding: 0px !important;
}

.tabs-bg {
  /* background-color: rgb(229, 242, 255); */
  background-color: #fcfcfc;
}

.active-tab {
  border-bottom: 2px solid #0073ee;
}

.tab-pannel {
  border-left: 2px solid #0073ee;
}

input[type=checkbox].switch_11 {
  font-size: 12px;
  appearance: none;
  width: 3em;
  height: 1.5em;
  background: #ddd;
  border-radius: 3em;
  position: relative;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease-in-out;
}

input[type=checkbox].switch_11:checked {
  background: #11c700;
}

input[type=checkbox].switch_11:after {
  position: absolute;
  content: "";
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
  transform: scale(0.7);
  left: 0;
  top: 0;
  transition: all 0.2s ease-in-out;
}

input[type=checkbox].switch_11:checked:after {
  left: calc(100% - 1.5em);
}

.z-700 {
  z-index: 700;
}

.z-800 {
  z-index: 800;
}

.side-navbar {
  width: 0;
  overflow-x: hidden;
}

.width-250 {
  width: 300px;
  animation: widthIncreasae 0.5s ease-in-out;
}

@keyframes widthIncreasae {
  0% {
    width: 0px;
  }
  100% {
    background-position: 300px;
  }
}
.side-navbar a {
  transition: 1s;
}

.custom-h-10 {
  height: 10%;
}

.custom-h-90 {
  height: 90%;
}

.f-18 {
  font-size: 18px;
}

.tabs-input-border {
  border: 1px solid #e6e6e6;
  width: 300px;
  outline: none;
}

.tabs-select-border {
  border: 1px solid #e6e6e6;
  width: 300px;
  outline: none;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 97%;
  background-position-y: 10px;
}

.opt-input {
  border: 1px solid #8b9caa;
  width: 200px;
  outline: none;
}

.cond-select-icon {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 7px;
}

/* .ant-table-pagination{
    width: 30%;
    margin: 15px auto!important;
  } */
.ant-pagination li {
  background-color: white !important;
}

.ant-pagination-options-size-changer {
  border: 1px solid #8b9caa !important;
}

.multi_select_field.ant-pagination-options-size-changer .ant-select-selector {
  background-color: white !important;
}

.multi_select_field.ant-pagination-options-size-changer .ant-select-selector .ant-select-selection-item {
  background-color: white !important;
}

.side-navbar-item:hover {
  background-color: #111f2c;
}

.uplaod-scvicon {
  animation: MoveUpDown 5s linear infinite;
}

@keyframes MoveUpDown {
  0%, 100% {
    transform: translateY(-0.5rem);
  }
  50% {
    transform: translateY(1ch);
  }
}
.heading-light-gray {
  color: #9e9e9e;
}

.multi_select_field.ant-select-selection-placeholder {
  color: #999999 !important;
  font-family: "Sora", sans-serif !important;
  font-size: 16px !important;
}

.mrt-2 {
  margin-top: -2px;
}

.row-reverse {
  flex-direction: row-reverse !important;
}

.pl-10 {
  padding-left: 10px;
}

.w-11 {
  width: 11%;
}

.inputfield-white {
  font-weight: 300;
  width: 100%;
  height: 45px;
  font-family: "Sora", sans-serif;
}

.test:after {
  content: "⠇";
  font-size: 30px;
}

.mobile-view {
  border: 4px solid black;
  border-radius: 8px;
}

.golden-view {
  border: 4px solid rgb(114, 114, 113);
  border-radius: 6px;
}

.head-border {
  border-top-left-radius: 2px 2px;
  border-top-right-radius: 2px 2px;
}

.activity-input-white {
  font-weight: 300;
  width: 100%;
  height: 30px;
  font-family: "Sora", sans-serif;
}

.acitivity-form-inputblack {
  font-weight: 300;
  width: 100%;
  height: 30px;
  font-family: "Sora", sans-serif;
  background-color: #000b15;
  border: 1px solid #1e293b;
}

.activiy-select-black {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 7px;
}

.activiy-select-gray {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 9px;
}

:where(.css-dev-only-do-not-override-2rgkd4).ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 8px 0px 0px 0px;
}

.ant-collapse-expand-icon {
  margin-top: 5px;
}

.activity-mddl {
  padding: 0px;
}

.multi_select_field.activity-mddl .ant-select-selector {
  background-color: white !important;
  color: black;
  border: none !important;
  padding: 0px 0px !important;
  padding-left: 0px !important;
  outline: none !important;
}

.edit-button {
  background-color: #f6f6f6;
}

.boarder-description {
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
}

.org-details div:nth-child(3) p:nth-child(1) {
  border-right: 1px solid #e6e6e6;
}

.org-details div:nth-child(6) p:nth-child(1) {
  border-right: 1px solid #e6e6e6;
}

.org-details div:nth-child(1) p:nth-child(2) {
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
}

.org-details div:nth-child(3) p:nth-child(2) {
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
}

.org-details div:nth-child(5) p:nth-child(2) {
  border-bottom: 1px solid #e6e6e6;
}

.org-details div:nth-child(4) p:nth-child(2) {
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

.org-details div:nth-child(6) p:nth-child(2) {
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

.site-form div:nth-child(5) {
  width: 100%;
}

.border-bottom {
  border-bottom: 1px solid #091724 !important;
}

.light-theme .css-dev-only-do-not-override-2rgkd4.ant-table-wrapper .ant-table-tbody > tr > td {
  border-bottom: none !important;
  border-bottom: 1px solid #e5e9eb !important;
  /* Light theme border color */
}

.dark-theme .css-dev-only-do-not-override-2rgkd4.ant-table-wrapper .ant-table-tbody > tr > td {
  border-bottom: 1px solid #1e293b !important;
  /* Dark theme border color */
}

.icon-white {
  color: white;
}

.ant-descriptions-item-label {
  color: white;
  /* border-width: 2px; */
}

.ant-descriptions {
  background-color: white;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  border-bottom: none;
}

.ant-descriptions-bordered {
  color: yellow;
}

.bordered-descriptions-content .ant-descriptions-item-content {
  /* padding: 8px 24px;
  width: 100%;
  height: 60px;
  top: 0 !important;
  bottom: 0 !important;
  background-color: #091724;
  color: white;
  border: 1px solid #1E293B;
  box-sizing: border-box;
  margin-bottom: -17px !important; */
  padding-left: 24px;
  width: 100%;
  height: 100%;
  top: 120px;
}

.bordered-descriptions-label .ant-descriptions-item-label {
  /* border: 4px solid #1E293B;
  border-width: 4px solid;
  /* padding-top: 8px; */
  /* padding-left: 24px; */
  /* padding: 4px 24px;
  border-radius: 2px;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  opacity: 1;
  color: white;
  height: 60px;
  background-color: #091724;
  margin-bottom: -17px !important; */
  border: 1px solid #e8e8e8;
  /* Add border inside each description item */
  border-width: 4px solid;
  padding-top: 8px;
  padding-left: 24px;
  width: 100%;
  height: 60px;
  background-color: #f0f0f0;
  top: 20px;
  color: #000000;
}

.ant-descriptions-row {
  padding: 0;
  margin: 0;
}

.multi_select_field.ant-select-focused {
  outline: none !important;
}

.move-to-right {
  transform: translateX(18px);
  transition: linear 0.2s;
}

.move-to-left {
  transform: translateX(-3px);
  transition: linear 0.2s;
}

.edit-button-dark {
  background-color: #0073ee !important;
}

.view-button-dark {
  background-color: #318ce7 !important;
}

.z-index-breads {
  z-index: 99999 !important;
}

.select_box_field {
  width: 100%;
  height: 45px;
  border-radius: 2px;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
}

.select_bg {
  background-color: #000b15;
}

.login_inputs {
  width: 525px;
}

.dark_toogle {
  width: 270px;
}

.bread-board {
  border: 1px solid #e6e6e6;
  border-left: none;
}

.dashboard_bread_bg_color {
  color: white;
  background-color: #091724;
  border-left: none;
}

.w-350 {
  width: 350px;
}

.w-53 {
  width: 53%;
}

.w-30 {
  width: 30%;
}

.reporting_wrapper {
  display: "flex";
  justify-content: "space-between";
}

.access_deneid_main {
  background-color: white;
  height: 100%;
  width: 100%;
}

.access_deneid_h1 {
  font-family: "Graphik", sans-serif !important;
  font-size: 65px !important;
  color: "#1D242E";
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loader {
  border: 5px solid #eaf0f6;
  border-radius: 100%;
  border-top: 5px solid #0073ee;
  animation: spinner 3s linear infinite;
  width: 75px;
  height: 75px;
}
.loader.lg {
  width: 75px;
  height: 75px;
}
.loader.sm {
  width: 35px;
  height: 35px;
}

.animated-text {
  color: #0073ee;
  font-size: 20px;
  margin-left: 10px;
}

.loading-dots-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-dots {
  text-align: center;
  font-size: 20px;
  margin-left: 5px;
}

.dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #0073ee;
  border-radius: 50%;
  margin-right: 8px;
  opacity: 0;
  animation: fadeIn 1s infinite linear;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.5s;
}

.dot:nth-child(3) {
  animation-delay: 1s;
}

.map_toggle_button {
  width: 122px;
  height: 40px;
  border-radius: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
}
.map_toggle_button .single_button {
  width: 56px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reporting_tooltip_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}
.reporting_tooltip_content h4 {
  color: #1d242e;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  font-family: "Graphik", sans-serif;
}
.reporting_tooltip_content h5 {
  color: #6f767e;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: "Sora", sans-serif;
}

.salesPitchDownloadButton {
  width: 366px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #d7eeff;
  color: #0073ee;
  border-radius: 8px;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 16px 0px;
}

.sales_pitch_downlaod_table {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.csvButtonRepoting {
  font-family: "Graphik", sans-serif;
  font-weight: 600;
  font-size: 16px;
  height: 40px;
  width: 133px;
  border: 1px solid #dde2e4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.selectColumnsButton {
  font-family: "Graphik", sans-serif;
  font-weight: 600;
  font-size: 16px;
  height: 40px;
  width: 121px;
  border: 1px solid #dde2e4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.csvButtonRepoting.disabled,
.selectColumnsButton.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(100%);
}

.text-button {
  border: none;
  background: none;
  color: #333;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  padding: 0;
  margin: 0;
}

.ant-table-measure-row {
  display: none;
  /* Hide the measure row */
}

.link_button {
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  color: #0073ee;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  padding: 10px;
}

.link_button:hover {
  color: #0053ce;
}

.group-container-selected-fields {
  border: 2px dashed #1d242e;
  position: relative;
  gap: 8px;
  margin-top: 32px;
  background-color: transparent;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;
}

.selected-field {
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  transition: all 0.3s ease;
  background-color: rgba(9, 88, 224, 0.7);
  border-radius: 8px;
  position: relative;
  color: #ffffff;
}

.sales-pitch-form-main-container {
  background: #fff;
  border: 1px solid #e6e6e6;
  padding: 24px 20px 0px 20px;
}

.sales-pitch-form-buttons {
  margin-top: 32px;
  display: flex;
  justify-content: flex-start;
  gap: 16px;
}

.border-radius-input-field {
  border-radius: 4px !important;
  transition: box-shadow 0.3s;
}

.border-radius-input-field:focus {
  box-shadow: 0px 0px 0px 3px rgba(0, 115, 238, 0.22);
}

.add_keyword_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
  gap: 6px;
  font-size: 16px;
  font-family: "Sora", sans-serif;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 10px;
}

.save_keyword_button {
  background-color: #0073ee;
  padding: 8px 69px;
  color: #ffffff;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
}

.cancle_keyword_button {
  padding: 8px 69px;
  color: rgba(255, 255, 255, 0.5);
  background-color: #091724;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  line-height: 100%;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid #091724;
}

/* Custom styles for Rating component */
.rating-container {
  margin-bottom: 1rem;
}

.rating-label {
  display: block;
  margin-bottom: 0.5rem;
  color: white;
}

.stars {
  display: flex;
}

.star {
  font-size: 2rem;
  color: #ccc;
  cursor: pointer;
  position: relative;
}

.star.filled {
  color: gold;
}

.star.half-filled::before {
  content: "★";
  position: absolute;
  left: 0;
  width: 50%;
  overflow: hidden;
  color: gold;
}

.single-Tab {
  border-bottom: 2px solid #0073ee;
}

.scrollable {
  height: 100%;
  overflow-y: scroll;
  border: 1px solid black;
  padding: 10px;
  margin-right: 10px;
  right: 0;
  top: 0;
  transition: right 0.3s ease-in-out !important;
}

.user-avatar {
  height: 100px;
  width: 100px;
}

.upload-user-image-container {
  width: 88px;
  height: 88px;
  background-color: #1d242e;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-user-image {
  width: 128px;
  height: 128px;
}

.image-conatiner {
  width: 88px;
  height: 88px;
  position: relative;
  border-radius: 50%;
}

.image-conatiner .user-image {
  width: 88px;
  height: 88px;
  border-radius: 50%;
}

.delete-image {
  width: 115px;
  height: 115px;
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.attedace-image {
  width: 125px;
  height: 125px;
  position: relative;
  border-radius: 4px;
}

.image-input-info {
  width: 70%;
}

.calling-button {
  color: white;
  width: 290px;
  height: 40px;
  background-color: #00835b;
  margin-left: 20px !important;
  padding-bottom: 5px;
  padding-top: 15px;
}

.end-calling {
  color: white;
  width: 290px;
  height: 40px;
  background-color: #e71d36;
  margin-left: 20px !important;
  padding-bottom: 5px;
  padding-top: 15px;
}

.text-line {
  stroke-dasharray: 500;
  stroke-dashoffset: 500;
  animation: dash 3s linear infinite, filling 3s ease-in infinite;
  font-size: 80px;
}

.text-line text {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-style: normal;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes filling {
  0% {
    fill: #10abfe;
    fill-opacity: 0;
  }
  70% {
    fill: transparent;
    fill-opacity: 0.3;
  }
  85% {
    fill: #0073ee;
    fill-opacity: 0.8;
  }
  100% {
    fill: #0073ee;
    fill-opacity: 1;
  }
}
.w-siderbar {
  width: 64px;
}

.icon-container {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background-color: #1d242e;
}

.w-880 {
  width: 880px;
}

.title-content {
  color: #667085;
}

.modal-title-container {
  border-bottom: 1px solid rgba(228, 228, 228, 0.2);
}

.instructions-list {
  color: #667085;
  font-size: 12px;
  padding-left: 20px;
}

.w-400 {
  width: 400px;
}

.input-field-container .group > div[data-focus=true] > label {
  color: #52525b !important;
}
.input-field-container .group div:first-child {
  background-color: #000b15 !important;
  color: white;
  border: 1px solid #1e293b;
  height: 58px;
  border-radius: 6px;
}
.input-field-container .group div:first-child label {
  font-size: 14px;
  color: white;
}
.input-field-container .group div:nth-child(2) input {
  background-color: #000b15;
  color: white !important;
  outline: none;
  font-size: 14px;
}

.select_field_container div:first-child .group div:nth-child(2) button {
  background-color: #000b15 !important;
  color: white;
  outline: none !important;
  font-size: 14px !important;
  border: 1px solid #1e293b;
  border-radius: 6px !important;
  height: 58px !important;
}
.select_field_container div:first-child .group div:nth-child(2) button div:nth-child(2) span {
  color: white;
}
.select_field_container div:first-child .group div:nth-child(2) button div:nth-child(1) span {
  color: white;
}
.select_field_container div:first-child .group div:nth-child(2) > button > label {
  color: #ecedee !important;
}
.select_field_container div:first-child .group div:nth-child(2) > button[data-focus=true] > label {
  color: #52525b !important;
}

.field-label {
  color: #ecedee;
}

.field-focused {
  color: #52525b;
  border: 1px solid #0073ee;
  border-radius: 6px;
}

.input-Datefield-container > :first-child > :first-child {
  background-color: #000b15 !important;
  color: white;
  border: 1px solid #1e293b;
  height: 58px !important;
  border-radius: 6px !important;
}
.input-Datefield-container > :first-child > :first-child > :first-child svg {
  border: none !important;
}
.input-Datefield-container > :first-child > :first-child > :nth-child(2) > :first-child div {
  color: white !important;
}

.font-graphik-important {
  font-family: "Graphik", sans-serif !important;
}

.ant-table-thead > tr > th.custom-header {
  background-color: #e3f2fe !important;
  color: #0073ee !important;
  position: relative;
}

.ant-table-thead > tr > th.custom-header > div {
  background-color: #e3f2fe;
  color: #0073ee !important;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/* Custom Table */
.custom-checkbox {
  position: relative;
  width: 16px;
  height: 16px;
  appearance: none;
  border: 1px solid #e5e9eb;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

.custom-checkbox:checked {
  background-color: #1890ff;
  border: 1px solid #1890ff;
}

.custom-checkbox:checked::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 43%;
  width: 6px;
  height: 10px;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  transform: translate(-50%, -50%) rotate(45deg);
}

.custom-checkbox-all {
  position: relative;
  width: 16px;
  height: 16px;
  appearance: none;
  border: 1px solid #e5e9eb;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

.custom-checkbox-all:checked {
  background-color: #1890ff;
}

.custom-checkbox-all:checked::before {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: 3px solid white;
}

.accordionClass {
  height: 56px;
  overflow: hidden;
  /* Hide any overflowing content during transition */
  transition: max-height 2s ease;
}

.accordionClass[data-open=true] {
  height: auto;
  /* Set a large enough max-height to accommodate the expanded content */
  margin-bottom: 10px;
  /* No need to specify transition again, it's inherited from the initial state */
}

.accordionClass h2 > button {
  padding: 0 !important;
  height: 56px;
}

.accordionClass[data-open=true] section > div.py-2 {
  padding: 0 !important;
}

/* Custom Table */
.outline-none {
  outline: none !important;
}

.outline-input-custom {
  background-color: #000b15;
  border: 1px solid #1e293b;
  border-radius: 5px;
  color: #ffffff;
}

.outline-input-custom > div {
  background-color: transparent;
}

.calender-icon > div > div > button {
  margin-top: -16px;
}

.calender-icon > div > span {
  color: #ffffff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-text-fill-color: #fff !important;
  box-shadow: 0 0 0px 1000px #000b15 inset !important;
  caret-color: #fff;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}

.custom-textarea > div:hover {
  background-color: transparent !important;
}

.custom-textarea > div {
  background-color: transparent !important;
}

.custom-textarea > div > label {
  color: #ffffff !important;
}

.custom-textarea > div[data-focus=true] > label {
  color: #52525b !important;
}

.custom-textarea > div > div > textarea {
  color: #ffffff !important;
}

.input:-webkit-autofill {
  font-size: 1rem;
  background-color: transparent !important;
}

.autofill {
  transform: translateY(-1rem);
  /* Adjust to ensure placeholder doesn't overlap */
  color: black;
  /* Or any color that makes it readable */
}

.customMultiSelect:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border: none !important;
}

.customMultiSelect.ant-select-focused:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  box-shadow: none !important;
}

.customMultiSelect:where(.css-dev-only-do-not-override-ccdg5a).ant-select .ant-select-selection-placeholder {
  color: black !important;
}

.dds_Dashboard .bg-default-100 {
  background: #fff;
  box-shadow: none;
}

.dds_Dashboard_dark .bg-default-100 {
  background: #000;
  box-shadow: none;
}

.swiper-button-prev,
.swiper-button-next {
  position: relative !important;
  width: fit-content !important;
  display: inline-block !important;
  color: black !important;
  margin-left: 10px !important;
  margin-top: 8px !important;
  height: auto !important;
  right: auto !important;
  left: auto !important;
  top: -45px !important;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px !important;
}

.swiper-pagination {
  float: left !important;
  margin-left: 20px !important;
  width: fit-content !important;
  font-size: 20px !important;
  margin-top: 10px !important;
  position: relative !important;
  display: inline-block !important;
  top: -50px !important;
  left: auto !important;
  right: auto !important;
}

.force-scrollbar {
  overflow-y: scroll !important;
  height: calc(130vh - 150px) !important;
  /* Adjust height as needed */
}

.force-scrollbar::-webkit-scrollbar {
  width: 2px;
}

.force-scrollbar::-webkit-scrollbar-thumb {
  background-color: #777;
  border-radius: 10px;
}

.progressbar {
  background-color: #eee;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
  border-radius: 20px;
  overflow: hidden;
  height: 10px;
  width: 100%;
}

.progress {
  animation: progress 2s infinite linear;
}

.left-right {
  transform-origin: 0% 50%;
}

@keyframes progress {
  0% {
    transform: translateX(0) scaleX(0);
  }
  25% {
    transform: translateX(0) scaleX(0.4);
  }
  50% {
    transform: translateX(100%) scaleX(0.5);
  }
  75% {
    transform: translateX(100%) scaleX(-0.4);
  }
  100% {
    transform: translateX(0) scaleX(0);
  }
}
.search_select_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-select .ant-select-selection-placeholder {
  color: #e1e1e1;
}

.search_select_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-select-multiple .ant-select-selection-overflow .ant-select-selection-item-content {
  color: white;
}

.search_select_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-select-multiple .ant-select-selection-overflow .ant-select-selection-item-remove {
  color: white;
}

.custom_dark_multi:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  background: black;
}

.custom_dark_multi:where(.css-dev-only-do-not-override-ccdg5a).ant-select .ant-select-selection-placeholder {
  color: white;
}

.draggable_dark_theme:where(.css-dev-only-do-not-override-ccdg5a).ant-table-wrapper .ant-table-thead > tr > th {
  color: white;
  background: #424242;
}

.ant-select-focused:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  border-color: transparent !important;
  box-shadow: none !important;
}

:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border: none !important;
}

:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
  border-color: transparent !important;
}

.search_select_field_dark :where(.css-dev-only-do-not-override-142vneq).ant-select .ant-select-selection-placeholder {
  color: rgb(185, 185, 185);
}

.search_select_field_dark :where(.css-1kf000u).ant-select .ant-select-selection-placeholder {
  color: rgb(185, 185, 185);
}

.search_select_field_dark .ant-select-selection-placeholder {
  color: rgb(185, 185, 185) !important;
}

.group[data-has-helper=true] .group-data-\\[has-helper\\=true\\]\\:flex {
  display: none;
}

/*Hold Multiline for multi select*/
.customMultiSelect .ant-select-selector {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  align-items: center;
  height: auto !important;
  padding: 4px 8px;
}

.customMultiSelect .ant-select-selection-overflow {
  display: flex;
  flex-wrap: nowrap;
}

.customMultiSelect .ant-select-selection-item {
  white-space: nowrap;
  margin-right: 8px;
}

.customMultiSelect .ant-select-selector::-webkit-scrollbar {
  height: 4px;
  display: none;
}

.customMultiSelect .ant-select-selector::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 2px;
}

.customMultiSelect .ant-select-selector:hover::-webkit-scrollbar {
  display: block;
}

.customMultiSelect .ant-select-selector::-webkit-scrollbar-thumb:hover {
  background-color: #aaa;
}

.ant-select-selector {
  border-radius: 0px !important;
  border: 0px !important;
}

.ant-select-selection-wrap {
  align-self: center !important;
}

.custom_dark_multi .ant-select-selector {
  background: black !important;
}

.custom_dark_multi .ant-select-selection-item {
  background: gray !important;
}

.custom_dark_multi .ant-select-selection-placeholder {
  color: gray !important;
}

/* Fix for dropdown overlap in expanded rows */
.ant-table-expanded-row > td {
  position: relative;
  z-index: 10;
}

.ant-table-expanded-row-fixed {
  position: relative;
  z-index: 11;
}

/* Ensure dropdowns in expanded rows appear above other content */
.ant-select-dropdown,
.ant-dropdown {
  z-index: 9999 !important;
}

/* Fix for table row expansion */
.ant-table-tbody > tr.ant-table-expanded-row > td {
  padding: 0 !important;
}

.ant-table-expanded-row .ant-select {
  position: relative;
}

/* Ensure proper stacking context for expanded content */
.expanded-row-content {
  position: relative;
  z-index: 20;
  background: white;
  padding-bottom: 150px !important;
}

/* Dark theme support */
.draggable_dark_theme .expanded-row-content {
  background: #1f1f1f;
}

/* Prevent overflow issues */
.card-board {
  position: relative;
  overflow: false !important;
}

.draggable-table-container {
  position: relative;
}

.Login_left_pannel {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  color: white;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  background-blend-mode: overlay;
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.75);
}

.login_left_panel_initial {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 20px;
}

.login_left_panel_internal_box {
  width: calc(100% - 60px);
}

.logo_and_text {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  gap: 24px;
  width: max-content;
  margin-bottom: 44px;
}
.logo_and_text img {
  width: 80px;
  height: 80px;
}
.logo_and_text .text img {
  width: 280px;
  height: 80px;
}

.content_below_logo .content_headingText {
  width: max-content;
}
.content_below_logo .content_headingText h1 {
  font-size: 46px;
  line-height: 52px;
}
.content_below_logo .content_headingText h2 {
  font-size: 46px;
  line-height: 60px;
  background: linear-gradient(to right, #10d6fe 0%, #0073ee 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content_below_logo .content_supporting_text {
  color: #93a2b3;
  font-size: 20px !important;
  line-height: 28px;
  margin-top: 12px;
  margin-bottom: 42px;
  width: 450px;
}
.content_below_logo .card_login {
  background-color: #111f2c;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
  width: 384px;
  padding: 20px 20px;
}
.content_below_logo .card_login .card_header {
  font-size: 28px;
  margin-bottom: 16px;
  line-height: 100%;
  font-weight: 600;
}
.content_below_logo .card_login .card_text {
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;
  color: #93a2b3;
}
.content_below_logo .card_login button {
  border-radius: 4px;
  background-color: #e07900;
  padding: 8px 16px;
}
.content_below_logo .card_right_section {
  padding-left: 24px;
}
.content_below_logo .card_right_section h1 {
  font-size: 24px;
  line-height: 100%;
}
.content_below_logo .card_right_section p {
  font-size: 16px;
  margin-top: 8px;
  line-height: 20px;
  color: #93a2b3;
}
.content_below_logo .bottom_section {
  color: #93a2b3;
  font-size: 20px !important;
  line-height: 28px;
  margin-top: 52px;
}

.heading {
  font-family: Graphic !important;
}

.supporting_text {
  font-family: "Sora", sans-serif !important;
}

.user-profile-image .upload-button {
  width: 100px;
  margin-top: 10px;
}

@media (max-width: 1680px) {
  .logo_and_text {
    gap: 20px;
  }
  .logo_and_text img {
    width: 70px;
    height: 70px;
  }
  .logo_and_text .text img {
    width: 250px;
    height: 60px;
  }
  .content_below_logo .content_headingText h1 {
    font-size: 32px;
    line-height: 40px;
  }
  .content_below_logo .content_headingText h2 {
    font-size: 32px;
    line-height: 40px;
  }
  .content_below_logo .card_login {
    width: 364px;
    padding: 16px 16px;
  }
  .content_below_logo .card_login .card_header {
    font-size: 22px;
    margin-bottom: 12px;
  }
  .content_below_logo .card_login .card_text {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .content_below_logo .card_login button {
    padding: 6px 12px;
  }
  .content_below_logo .card_right_section h1 {
    font-size: 16px;
  }
  .content_below_logo .card_right_section p {
    font-size: 12px;
    margin-top: 6px;
    line-height: 16px;
  }
  .content_below_logo .bottom_section {
    font-size: 16px !important;
    line-height: 24px;
    margin-top: 32px;
  }
  .w-880 {
    width: 880px;
  }
}
@media (max-width: 1440px) {
  .w-880 {
    width: 880px;
  }
}
@media (max-width: 1365px) {
  .logo_and_text {
    gap: 20px;
  }
  .logo_and_text img {
    width: 70px;
    height: 70px;
  }
  .logo_and_text .text img {
    width: 250px;
    height: 60px;
  }
  .content_below_logo .content_headingText h1 {
    font-size: 32px;
    line-height: 40px;
  }
  .content_below_logo .content_headingText h2 {
    font-size: 32px;
    line-height: 40px;
  }
  .content_below_logo .card_login {
    width: 364px;
    padding: 16px 16px;
  }
  .content_below_logo .card_login .card_header {
    font-size: 22px;
    margin-bottom: 12px;
  }
  .content_below_logo .card_login .card_text {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .content_below_logo .card_login button {
    padding: 6px 12px;
  }
  .content_below_logo .card_right_section h1 {
    font-size: 16px;
  }
  .content_below_logo .card_right_section p {
    font-size: 12px;
    margin-top: 6px;
    line-height: 16px;
  }
  .content_below_logo .bottom_section {
    font-size: 16px !important;
    line-height: 24px;
    margin-top: 32px;
  }
  .w-880 {
    width: 880px;
  }
}
@media (max-width: 1279px) {
  .w-880 {
    width: 880px;
  }
}
@media (max-width: 1024px) {
  .w-880 {
    width: 780px;
  }
  .dashboard_card_main {
    width: 100%;
    height: 100%;
  }
  .card_title {
    font-size: 21px;
  }
  .card_description {
    font-size: 14px;
  }
}
@media (max-width: 1023px) {
  .w-880 {
    width: 600px;
  }
  .login_left_panel_initial {
    padding: 5%;
  }
  .login_left_panel_internal_box {
    width: 100%;
  }
  .logo_and_text {
    gap: 20px;
    margin-bottom: 10px;
  }
}
@media (max-width: 642px) {
  .map_toggle_button {
    width: 100%;
  }
  .map_toggle_button .single_button {
    width: 100%;
  }
  .border-right-only {
    border-right: 0px;
  }
  .image-input-info {
    width: 100%;
  }
  .csvButtonRepoting {
    width: 100%;
  }
  .selectColumnsButton {
    width: 100%;
  }
  .w-siderbar {
    width: 55px;
  }
  .w-880 {
    width: 600px;
  }
  .dashboard_card_inner_right {
    padding: 0px 0px 0px 10px;
  }
  .card_title {
    font-size: 20px;
  }
  .card_description {
    font-size: 12px;
  }
  .content_below_logo .content_headingText h1 {
    font-size: 24px;
    line-height: 28px;
  }
  .content_below_logo .content_headingText h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .content_below_logo .content_supporting_text {
    font-size: 16px !important;
    line-height: 20px;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 90%;
  }
  .content_below_logo .card_login {
    width: 364px;
    padding: 16px 16px;
  }
  .content_below_logo .card_login .card_header {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .content_below_logo .card_login .card_text {
    font-size: 14px;
    line-height: 18px;
  }
  .content_below_logo .card_login button {
    font-size: 14px;
  }
  .content_below_logo .card_right_section h1 {
    font-size: 14px;
  }
  .content_below_logo .card_right_section p {
    font-size: 10px;
    line-height: 14px;
  }
  .content_below_logo .bottom_section {
    font-size: 10px !important;
    line-height: 12px;
    margin-top: 24px;
  }
}
@media (max-width: 440px) {
  .w-880 {
    width: 400px;
  }
}
@media (max-width: 380px) {
  .w-880 {
    width: 880px;
  }
}
.filterbar {
  display: block;
}
.filterbar .filterbar_inner {
  margin-top: 10px;
}
.filterbar .header_searchable {
  width: 150px;
  min-width: 150px;
}

.dashboard_header_main .top_header_filters {
  padding: 10px 0;
  justify-content: right;
}

.search_select_field,
.search_datepicker_field {
  display: flex;
  align-items: center;
  border-right: 1px solid #E6E6E6;
}
.search_select_field .search_select_calander_icon img,
.search_datepicker_field .search_select_calander_icon img {
  min-width: 18px;
}
.search_select_field .header_searchable,
.search_select_field .header_datepicker,
.search_datepicker_field .header_searchable,
.search_datepicker_field .header_datepicker {
  min-width: 120px;
  text-align: center;
}
.search_select_field .header_searchable.border-gray-500,
.search_select_field .header_datepicker.border-gray-500,
.search_datepicker_field .header_searchable.border-gray-500,
.search_datepicker_field .header_datepicker.border-gray-500 {
  border-color: #d1d1d1;
}
.search_select_field .header_searchable .ant-select-selector,
.search_select_field .header_searchable .ant-picker,
.search_select_field .header_datepicker .ant-select-selector,
.search_select_field .header_datepicker .ant-picker,
.search_datepicker_field .header_searchable .ant-select-selector,
.search_datepicker_field .header_searchable .ant-picker,
.search_datepicker_field .header_datepicker .ant-select-selector,
.search_datepicker_field .header_datepicker .ant-picker {
  font-family: "Graphik", sans-serif !important;
  border: none !important;
  background-color: transparent !important;
}
.search_select_field .header_searchable .ant-select-selector:focus,
.search_select_field .header_searchable .ant-picker:focus,
.search_select_field .header_datepicker .ant-select-selector:focus,
.search_select_field .header_datepicker .ant-picker:focus,
.search_datepicker_field .header_searchable .ant-select-selector:focus,
.search_datepicker_field .header_searchable .ant-picker:focus,
.search_datepicker_field .header_datepicker .ant-select-selector:focus,
.search_datepicker_field .header_datepicker .ant-picker:focus {
  outline: none;
  box-shadow: none;
}
.search_select_field .header_searchable .ant-select-selector .ant-select-selection-item,
.search_select_field .header_searchable .ant-select-selector .ant-picker-input > input,
.search_select_field .header_searchable .ant-picker .ant-select-selection-item,
.search_select_field .header_searchable .ant-picker .ant-picker-input > input,
.search_select_field .header_datepicker .ant-select-selector .ant-select-selection-item,
.search_select_field .header_datepicker .ant-select-selector .ant-picker-input > input,
.search_select_field .header_datepicker .ant-picker .ant-select-selection-item,
.search_select_field .header_datepicker .ant-picker .ant-picker-input > input,
.search_datepicker_field .header_searchable .ant-select-selector .ant-select-selection-item,
.search_datepicker_field .header_searchable .ant-select-selector .ant-picker-input > input,
.search_datepicker_field .header_searchable .ant-picker .ant-select-selection-item,
.search_datepicker_field .header_searchable .ant-picker .ant-picker-input > input,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-select-selection-item,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-picker-input > input,
.search_datepicker_field .header_datepicker .ant-picker .ant-select-selection-item,
.search_datepicker_field .header_datepicker .ant-picker .ant-picker-input > input {
  font-size: 18px !important;
  font-weight: 500;
  margin-right: 5px;
  background-color: transparent !important;
  color: #33383f;
}
.search_select_field .header_searchable .ant-select-selector .ant-select-selection-item:focus,
.search_select_field .header_searchable .ant-select-selector .ant-picker-input > input:focus,
.search_select_field .header_searchable .ant-picker .ant-select-selection-item:focus,
.search_select_field .header_searchable .ant-picker .ant-picker-input > input:focus,
.search_select_field .header_datepicker .ant-select-selector .ant-select-selection-item:focus,
.search_select_field .header_datepicker .ant-select-selector .ant-picker-input > input:focus,
.search_select_field .header_datepicker .ant-picker .ant-select-selection-item:focus,
.search_select_field .header_datepicker .ant-picker .ant-picker-input > input:focus,
.search_datepicker_field .header_searchable .ant-select-selector .ant-select-selection-item:focus,
.search_datepicker_field .header_searchable .ant-select-selector .ant-picker-input > input:focus,
.search_datepicker_field .header_searchable .ant-picker .ant-select-selection-item:focus,
.search_datepicker_field .header_searchable .ant-picker .ant-picker-input > input:focus,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-select-selection-item:focus,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-picker-input > input:focus,
.search_datepicker_field .header_datepicker .ant-picker .ant-select-selection-item:focus,
.search_datepicker_field .header_datepicker .ant-picker .ant-picker-input > input:focus {
  outline: none;
}
.search_select_field .header_searchable .ant-select-selector .ant-select-selection-placeholder,
.search_select_field .header_searchable .ant-picker .ant-select-selection-placeholder,
.search_select_field .header_datepicker .ant-select-selector .ant-select-selection-placeholder,
.search_select_field .header_datepicker .ant-picker .ant-select-selection-placeholder,
.search_datepicker_field .header_searchable .ant-select-selector .ant-select-selection-placeholder,
.search_datepicker_field .header_searchable .ant-picker .ant-select-selection-placeholder,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-select-selection-placeholder,
.search_datepicker_field .header_datepicker .ant-picker .ant-select-selection-placeholder {
  font-size: 18px !important;
}
.search_select_field .header_searchable .ant-select-arrow .anticon svg,
.search_select_field .header_datepicker .ant-select-arrow .anticon svg,
.search_datepicker_field .header_searchable .ant-select-arrow .anticon svg,
.search_datepicker_field .header_datepicker .ant-select-arrow .anticon svg {
  fill: #9d9d9d;
  font-weight: bold;
}

.search_select_field_dark,
.search_datepicker_field {
  display: flex;
  align-items: center;
  border-right: 1px solid rgba(255, 255, 255, 0.4509803922);
}
.search_select_field_dark .search_select_calander_icon img,
.search_datepicker_field .search_select_calander_icon img {
  min-width: 18px;
}
.search_select_field_dark .header_searchable,
.search_select_field_dark .header_datepicker,
.search_datepicker_field .header_searchable,
.search_datepicker_field .header_datepicker {
  min-width: 120px;
  text-align: center;
}
.search_select_field_dark .header_searchable.border-gray-500,
.search_select_field_dark .header_datepicker.border-gray-500,
.search_datepicker_field .header_searchable.border-gray-500,
.search_datepicker_field .header_datepicker.border-gray-500 {
  border-color: #d1d1d1;
}
.search_select_field_dark .header_searchable .ant-select-selector,
.search_select_field_dark .header_searchable .ant-picker,
.search_select_field_dark .header_datepicker .ant-select-selector,
.search_select_field_dark .header_datepicker .ant-picker,
.search_datepicker_field .header_searchable .ant-select-selector,
.search_datepicker_field .header_searchable .ant-picker,
.search_datepicker_field .header_datepicker .ant-select-selector,
.search_datepicker_field .header_datepicker .ant-picker {
  font-family: "Graphik", sans-serif !important;
  border: none !important;
  background-color: transparent !important;
}
.search_select_field_dark .header_searchable .ant-select-selector:focus,
.search_select_field_dark .header_searchable .ant-picker:focus,
.search_select_field_dark .header_datepicker .ant-select-selector:focus,
.search_select_field_dark .header_datepicker .ant-picker:focus,
.search_datepicker_field .header_searchable .ant-select-selector:focus,
.search_datepicker_field .header_searchable .ant-picker:focus,
.search_datepicker_field .header_datepicker .ant-select-selector:focus,
.search_datepicker_field .header_datepicker .ant-picker:focus {
  outline: none;
  box-shadow: none;
}
.search_select_field_dark .header_searchable .ant-select-selector .ant-select-selection-item,
.search_select_field_dark .header_searchable .ant-select-selector .ant-picker-input > input,
.search_select_field_dark .header_searchable .ant-picker .ant-select-selection-item,
.search_select_field_dark .header_searchable .ant-picker .ant-picker-input > input,
.search_select_field_dark .header_datepicker .ant-select-selector .ant-select-selection-item,
.search_select_field_dark .header_datepicker .ant-select-selector .ant-picker-input > input,
.search_select_field_dark .header_datepicker .ant-picker .ant-select-selection-item,
.search_select_field_dark .header_datepicker .ant-picker .ant-picker-input > input,
.search_datepicker_field .header_searchable .ant-select-selector .ant-select-selection-item,
.search_datepicker_field .header_searchable .ant-select-selector .ant-picker-input > input,
.search_datepicker_field .header_searchable .ant-picker .ant-select-selection-item,
.search_datepicker_field .header_searchable .ant-picker .ant-picker-input > input,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-select-selection-item,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-picker-input > input,
.search_datepicker_field .header_datepicker .ant-picker .ant-select-selection-item,
.search_datepicker_field .header_datepicker .ant-picker .ant-picker-input > input {
  font-size: 18px !important;
  font-weight: 500;
  margin-right: 5px;
  background-color: transparent !important;
  color: #ffffff;
}
.search_select_field_dark .header_searchable .ant-select-selector .ant-select-selection-item:focus,
.search_select_field_dark .header_searchable .ant-select-selector .ant-picker-input > input:focus,
.search_select_field_dark .header_searchable .ant-picker .ant-select-selection-item:focus,
.search_select_field_dark .header_searchable .ant-picker .ant-picker-input > input:focus,
.search_select_field_dark .header_datepicker .ant-select-selector .ant-select-selection-item:focus,
.search_select_field_dark .header_datepicker .ant-select-selector .ant-picker-input > input:focus,
.search_select_field_dark .header_datepicker .ant-picker .ant-select-selection-item:focus,
.search_select_field_dark .header_datepicker .ant-picker .ant-picker-input > input:focus,
.search_datepicker_field .header_searchable .ant-select-selector .ant-select-selection-item:focus,
.search_datepicker_field .header_searchable .ant-select-selector .ant-picker-input > input:focus,
.search_datepicker_field .header_searchable .ant-picker .ant-select-selection-item:focus,
.search_datepicker_field .header_searchable .ant-picker .ant-picker-input > input:focus,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-select-selection-item:focus,
.search_datepicker_field .header_datepicker .ant-select-selector .ant-picker-input > input:focus,
.search_datepicker_field .header_datepicker .ant-picker .ant-select-selection-item:focus,
.search_datepicker_field .header_datepicker .ant-picker .ant-picker-input > input:focus {
  outline: none;
}
.search_select_field_dark .header_searchable .ant-select-arrow .anticon svg,
.search_select_field_dark .header_datepicker .ant-select-arrow .anticon svg,
.search_datepicker_field .header_searchable .ant-select-arrow .anticon svg,
.search_datepicker_field .header_datepicker .ant-select-arrow .anticon svg {
  fill: #9d9d9d;
  font-weight: bold;
}

.my-select .ant-select-selection-overflow {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.my-select .ant-select-selection-overflow-item {
  flex-shrink: 0;
}

.apply_filter_button {
  height: 40px;
  background-color: #0073EE;
  padding: 10px 12px;
  color: #FFFFFF;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  line-height: 100%;
  font-weight: 500;
  border-radius: 8px;
  margin-left: 8px;
}

.isDisabled {
  background-color: #D4D4D4;
  cursor: not-allowed;
}

.apply_filter_button:active {
  background-color: #005bb5;
  /* Darker shade for the click effect */
  transform: scale(0.98);
  /* Slightly shrink the button */
}

.cancle_filter_button {
  height: 40px;
  padding: 10px 12px;
  color: #1D242E;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  line-height: 100%;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid #E5E9EB;
}

.dark_btn .cancle_filter_button {
  height: 40px;
  padding: 10px 12px;
  color: #ffffff;
  font-family: "Graphik", sans-serif;
  font-size: 16px;
  line-height: 100%;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid #E5E9EB;
}

.cancle_filter_button:active {
  background-color: #F0F0F0;
  /* Slightly darker background for the click effect */
  border-color: #C0C0C0;
  /* Darker border for the click effect */
  transform: scale(0.98);
  /* Slightly shrink the button */
}

:where(.css-dev-only-do-not-override-2rgkd4).ant-picker {
  box-sizing: border-box;
  margin: 0px 10px;
  padding: 4px 11px 4px;
  color: rgb(51, 56, 63) !important;
  font-size: 12px !important;
  line-height: 1;
  list-style: none;
  font-family: "Graphik", sans-serif !important;
  position: relative;
  display: inline-flex;
  align-items: center;
  background: transparent !important;
  border-radius: 6px;
  transition: border 0.2s, box-shadow 0.2s;
  width: 221px !important;
}

.crossClass .ant-select-clear {
  top: 35%;
  right: 20%;
  font-size: 18px;
  opacity: 1;
}

.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker-outlined {
  background: rgb(103, 103, 103);
  border-color: black;
}

.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker {
  color: white;
}

.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker .ant-picker-input > input::placeholder {
  color: #e3e3e3;
}

html, body {
  height: 100%;
  background-color: black;
  margin: 0;
  overflow-x: hidden;
  overflow: -moz-scrollbars-vertical;
  font-family: "Graphik", sans-serif;
  /* overflow-y: scroll; */
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/assets/sass/custom.scss","webpack://./src/assets/sass/userManagement.scss","webpack://./src/assets/sass/responsive.scss","webpack://./src/assets/sass/filters.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,cAAA;EACA,kBAAA;ADEF;;ACCA;EACE,+BAAA;ADEF;;ACCA;EACE,cAAA;ADEF;;ACCA;EACE,cAAA;ADEF;;ACCA;EACE,yBAAA;ADEF;;ACCA;EACE,aAAA;ADEF;;ACCA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;ADEF;;ACCA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,+EAAA;ADEF;;ACgBA;EAGE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;ADbF;;ACgBA;EAGE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;ADbF;;ACgBA;EAME,mBAAA;ADlBF;;ACqBA;EACE,sBAAA;EACA,oFAAA;ADlBF;;AC0BA;EACE,cAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,YAAA;ADvBF;;AC0BA;EACE,8DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADvBF;;AC0BA;EACE,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;ADvBF;;AC0BA;EACE,gCAAA;ADvBF;;AC0BA;EACE,UAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;ADvBF;;AC0BA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,aAAA;EACA,YAAA;ADvBF;;AC0BA;EACE,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;ADvBF;;AC0BA;;EAEE,YAAA;ADvBF;;AC0BA;EACE,YAAA;ADvBF;;AC0BA;EACE,UAAA;EACA,YAAA;ADvBF;;AC0BA;EACE,cAAA;EACA,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;ADvBF;;AC0BA;EACE,6DAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;ADvBF;;AC0BA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADvBF;;AC0BA;EACE,6BAAA;EACA,2CAAA;ADvBF;;AC0BA;EACE,YAAA;EACA,yBAAA;ADvBF;;AC0BA;EACE,yBAAA;ADvBF;;AC0BA;EACE,eAAA;EACA,gBAAA;ADvBF;;AC0BA;EACE,eAAA;ADvBF;;AC0BA;EACE,aAAA;ADvBF;;AC0BA;EACE,cAAA;ADvBF;;AC0BA;EACE,aAAA;ADvBF;;AC0BA;EACE,YAAA;EACA,8BAAA;EACA,iBAAA;ADvBF;;AC0BA;EACE,kBAAA;ADvBF;;AC0BA;EACE,aAAA;ADvBF;;AC0BA;EACE,UAAA;ADvBF;;AC0BA;EACE,YAAA;EACA,YAAA;ADvBF;;AC0BA;EAEE,6CAAA;ADvBF;;AC0BA;EACE;IAEE,kCAAA;EDvBF;EC0BA;IAEE,mCAAA;EDxBF;EC2BA;IAEE,oCAAA;EDzBF;EC4BA;IAEE,oCAAA;ED1BF;EC6BA;IAEE,oCAAA;ED3BF;AACF;AC8BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,wBAAA;EACA,wCAAA;EACA,+BAAA;AD5BF;;AC+BA;EACE,4BAAA;EACA,uBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;AD5BF;;AC+BA;;EAEE,0BAAA;EACA,yBAAA;AD5BF;;AC+BA;;;EAGE,oCAAA;AD5BF;;AC+BA;;;EAGE,iCAAA;AD5BF;;AC+BA;EACE,oCAAA;EACA,uBAAA;EACA,6CAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;AD5BF;;AC+BA;EACE,oCAAA;EACA,uBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iCAAA;EACA,4BAAA;AD5BF;;AC+BA;EACE,oCAAA;EAOA,oCAAA;EACA,6BAAA;EACA,uBAAA;ADpCF;;ACuCA;EACE,oCAAA;EACA,yBAAA;EACA,6CAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;AD5BF;;AC+BA;EACE,oCAAA;EACA,yBAAA;EACA,0CAAA;EACA,0BAAA;EACA,iCAAA;EACA,4BAAA;AD5BF;;AC+BA;EACE,kCAAA;EACA,uBAAA;EACA,yCAAA;AD5BF;;AC+BA;EACE,oCAAA;AD5BF;;AC+BA;EACE,uBAAA;AD5BF;;AC+BA;EACE,yBAAA;EACA,cAAA;AD5BF;;AC+BA;EACE,sBAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,oCAAA;EACA,YAAA;AD5BF;;AC+BA;EACE,sCAAA;AD5BF;;AC+BA;EACE,yBAAA;AD5BF;;AC+BA;EACE,+BAAA;AD5BF;;AC+BA;EACE,0BAAA;AD5BF;;AC+BA;EACE,+HAAA;EAOA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,0BAAA;EACA,sDAAA;ADlCF;;ACqCA;EACE;IACE,2BAAA;EDlCF;ECqCA;IACE,2BAAA;EDnCF;ECsCA;IACE,4BAAA;EDpCF;AACF;ACuCA;EACE,yBAAA;ADrCF;;ACwCA;EACE,kBAAA;ADrCF;;ACwCA;EACE,WAAA;ADrCF;;ACwCA;EACE,cAAA;ADrCF;;ACwCA;EACE,+CAAA;EACA,uDAAA;EACA,oDAAA;ADrCF;;ACwCA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;ADrCF;;ACwCA;EACE,WAAA;EACA,WAAA;ADrCF;;ACwCA;EACE,eAAA;EAGA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EAEA,gCAAA;ADrCF;;ACwCA;EACE,mBAAA;ADrCF;;ACwCA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAEA,yCAAA;EAEA,qBAAA;EACA,UAAA;EACA,WAAA;EAEA,gCAAA;ADrCF;;ACwCA;EACE,wBAAA;ADrCF;;ACwCA;EACE,cAAA;ADrCF;;ACwCA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;ADrCF;;ACwCA;;EAEE,uBAAA;ADrCF;;ACwCA;EACE,oCAAA;ADrCF;;ACwCA;EACE,uBAAA;ADrCF;;ACwCA;EACE,yBAAA;ADrCF;;ACwCA;EACE,iBAAA;ADrCF;;ACwCA;EACE,UAAA;ADrCF;;ACwCA;EACE,UAAA;ADrCF;;ACwCA,UAAA;AACA;EACE,yCAAA;EACA,mBAAA;EACA,yBAAA;ADrCF;;ACwCA,WAAA;AACA;EACE,8BAAA;EACA,yBAAA;ADrCF;;ACwCA,oBAAA;AACA;EACE,mBAAA;ADrCF;;ACwCA,yBAAA;AACA;EACE,WAAA;EACA,mCAAA;ADrCF;;ACwCA,mCAAA;AACA;EACE,mBAAA;EACA,gDAAA;ADrCF;;ACwCA,oCAAA;AACA;EACE,mBAAA;EACA,gDAAA;ADrCF;;ACwCA,6CAAA;AACA;EACE,mBAAA;EACA,yDAAA;ADrCF;;ACwCA;;EAYE,mBAAA;AD/CF;;ACkDA;EACE,oCAAA;EACA,iCAAA;EACA,6BAAA;EACA,oDAAA;EACA,2BAAA;EACA,gDAAA;AD/CF;;ACkDA,mDAAA;AACA;EACE,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,oDAAA;EACA,2BAAA;AD/CF;;ACkDA;;EAYE,qBAAA;ADzDF;;AC4DA;;GAAA;AAGA;EACE,uBAAA;ADzDF;;AC4DA;EACE,0CAAA;EACA,yBAAA;ADzDF;;AC4DA;EACE,gCAAA;ADzDF;;AC4DA;EACE,8BAAA;ADzDF;;AC4DA;EACE,eAAA;EAGA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EAEA,gCAAA;ADzDF;;AC4DA;EACE,mBAAA;ADzDF;;AC4DA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EAEA,yCAAA;EAEA,qBAAA;EACA,OAAA;EACA,MAAA;EAEA,gCAAA;ADzDF;;AC4DA;EACE,wBAAA;ADzDF;;AC4DA;EACE,YAAA;ADzDF;;AC4DA;EACE,YAAA;ADzDF;;AC4DA;EACE,QAAA;EACA,kBAAA;ADzDF;;AC4DA;EACE,YAAA;EACA,0CAAA;ADzDF;;AC4DA;EACE;IACE,UAAA;EDzDF;EC4DA;IACE,0BAAA;ED1DF;AACF;AC6DA;EACE,cAAA;AD3DF;;AC8DA;EACE,WAAA;AD3DF;;AC8DA;EACE,WAAA;AD3DF;;AC8DA;EACE,eAAA;AD3DF;;AC8DA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;AD3DF;;AC8DA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EAGA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AD3DF;;AC8DA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;AD3DF;;AC8DA;EAGE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;AD3DF;;AC8DA;;;KAAA;AAIA;EACE,kCAAA;AD3DF;;AC8DA;EACE,oCAAA;AD3DF;;AC8DA;EACE,kCAAA;AD3DF;;AC8DA;EAGE,kCAAA;AD7DF;;ACgEA;EACE,yBAAA;AD7DF;;ACgEA;EACE,wCAAA;AD7DF;;ACgEA;EACE;IAEE,8BAAA;ED9DF;ECiEA;IACE,0BAAA;ED/DF;AACF;ACkEA;EACE,cAAA;ADhEF;;ACyEA;EACE,yBAAA;EACA,0CAAA;EACA,0BAAA;ADtEF;;ACyEA;EACE,gBAAA;ADtEF;;ACyEA;EACE,sCAAA;ADtEF;;ACyEA;EACE,kBAAA;ADtEF;;ACyEA;EACE,UAAA;ADtEF;;ACyEA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;ADtEF;;ACyEA;EACE,YAAA;EACA,eAAA;ADtEF;;ACyEA;EACE,uBAAA;EACA,kBAAA;ADtEF;;ACyEA;EACE,oCAAA;EACA,kBAAA;ADtEF;;ACyEA;EACE,+BAAA;EACA,gCAAA;ADtEF;;ACyEA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;ADtEF;;ACyEA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;EACA,yBAAA;ADtEF;;ACyEA;EAGE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;ADtEF;;ACyEA;EAGE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;ADtEF;;ACyEA;EAGE,wBAAA;ADxEF;;AC2EA;EACE,eAAA;ADxEF;;AC2EA;EACE,YAAA;ADxEF;;AC2EA;EACE,kCAAA;EAEA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;ADxEF;;AC2EA;EACE,yBAAA;ADxEF;;AC2EA;EACE,6BAAA;EACA,gCAAA;EACA,8BAAA;ADxEF;;AC2EA;EACE,+BAAA;ADxEF;;AC2EA;EACE,+BAAA;ADxEF;;AC2EA;EACE,+BAAA;EACA,8BAAA;ADxEF;;AC2EA;EACE,+BAAA;EACA,8BAAA;ADxEF;;AC2EA;EACE,gCAAA;ADxEF;;AC2EA;EACE,+BAAA;EACA,8BAAA;EACA,gCAAA;ADxEF;;AC2EA;EACE,+BAAA;EACA,8BAAA;EACA,gCAAA;ADxEF;;AC2EA;EACE,WAAA;ADxEF;;AC2EA;EACE,2CAAA;ADxEF;;AC2EA;EAKE,8BAAA;EAQA,2CAAA;EACA,6BAAA;ADrFF;;ACwFA;EAKE,2CAAA;EACA,4BAAA;ADpFF;;ACuFA;EACE,YAAA;ADpFF;;ACuFA;EACE,YAAA;EACA,uBAAA;ADpFF;;ACuFA;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ADpFF;;ACuFA;EACE,aAAA;ADpFF;;ACuFA;EACE;;;;;;;;;oCAAA;EAWA,kBAAA;EACA,WAAA;EAEA,YAAA;EACA,UAAA;ADrFF;;ACwFA;EACE;;wBAAA;EAGA,wBAAA;EACA;;;;;;;;;oCAAA;EAUA,yBAAA;EACA,4CAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;ADrFF;;ACwFA;EACE,UAAA;EACA,SAAA;ADrFF;;ACwFA;EACE,wBAAA;ADrFF;;ACwFA;EACE,2BAAA;EACA,uBAAA;ADrFF;;ACwFA;EACE,2BAAA;EACA,uBAAA;ADrFF;;ACwFA;EACE,oCAAA;ADrFF;;ACwFA;EACE,oCAAA;ADrFF;;ACwFA;EACE,yBAAA;ADrFF;;ACwFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;ADrFF;;AC0FA;EACE,yBAAA;ADvFF;;AC0FA;EACE,YAAA;ADvFF;;AC0FA;EACE,YAAA;ADvFF;;AC0FA;EACE,yBAAA;EACA,iBAAA;ADvFF;;AC0FA;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;ADvFF;;AC0FA;EACE,YAAA;ADvFF;;AC0FA;EACE,UAAA;ADvFF;;AC0FA;EACE,UAAA;ADvFF;;AC0FA;EACE,eAAA;EACA,gCAAA;ADvFF;;AC2FA;EACE,uBAAA;EACA,YAAA;EACA,WAAA;ADxFF;;AC2FA;EACE,6CAAA;EACA,0BAAA;EACA,gBAAA;ADxFF;;AC2FA;EACE;IACE,uBAAA;EDxFF;EC2FA;IACE,yBAAA;EDzFF;AACF;AC4FA;EACE;IACE,UAAA;ED1FF;EC6FA;IACE,UAAA;ED3FF;EC8FA;IACE,UAAA;ED5FF;AACF;AC+FA;EACE,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;AD7FF;AC+FE;EACE,WAAA;EACA,YAAA;AD7FJ;ACgGE;EACE,WAAA;EACA,YAAA;AD9FJ;;ACkGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AD/FF;;ACkGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AD/FF;;ACkGA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AD/FF;;ACkGA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,oCAAA;AD/FF;;ACkGA;EACE,mBAAA;AD/FF;;ACkGA;EACE,qBAAA;AD/FF;;ACkGA;EACE,mBAAA;AD/FF;;ACkGA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AD/FF;ACiGE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AD/FJ;;ACmGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ADhGF;ACkGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;ADhGJ;ACmGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;ADjGJ;;ACqGA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ADlGF;;ACqGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;ADlGF;;ACqGA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;ADlGF;;ACqGA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;ADlGF;;ACqGA;;EAEE,YAAA;EACA,mBAAA;EACA,uBAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,SAAA;ADlGF;;ACqGA;EACE,aAAA;EACA,yBAAA;ADlGF;;ACqGA;EACE,kCAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;ADlGF;;ACqGA;EACE,cAAA;ADlGF;;ACqGA;EACE,0BAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;ADlGF;;ACqGA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;ADlGF;;ACqGA;EACE,gBAAA;EACA,yBAAA;EACA,2BAAA;ADlGF;;ACqGA;EACE,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;ADlGF;;ACqGA;EACE,6BAAA;EACA,2BAAA;ADlGF;;ACqGA;EACE,mDAAA;ADlGF;;ACqGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;ADlGF;;ACqGA;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ADlGF;;ACqGA;EACE,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ADlGF;;ACqGA,uCAAA;AACA;EACE,mBAAA;ADlGF;;ACqGA;EACE,cAAA;EACA,qBAAA;EACA,YAAA;ADlGF;;ACqGA;EACE,aAAA;ADlGF;;ACqGA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;ADlGF;;ACqGA;EACE,WAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ADlGF;;ACqGA;EACE,gCAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6CAAA;ADlGF;;ACqGA;EACE,aAAA;EACA,YAAA;ADlGF;;ACqGA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,aAAA;ADlGF;;ACqGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ADlGF;;ACqGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;ADlGF;;ACqGA;EACE,UAAA;ADlGF;;ACqGA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EAEA,4BAAA;EACA,mBAAA;EACA,iBAAA;ADnGF;;ACuGA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EAIA,4BAAA;EACA,mBAAA;EACA,iBAAA;ADvGF;;AC0GA;EACE,qBAAA;EACA,sBAAA;EACA,+DACE;EAEF,eAAA;ADzGF;;AC4GA;EACE,yCAAA;EACA,mBAAA;EACA,kBAAA;ADzGF;;AC4GA;EACE;IACE,oBAAA;EDzGF;AACF;AC4GA;EACE;IACE,aAAA;IACA,eAAA;ED1GF;EC6GA;IACE,iBAAA;IACA,iBAAA;ED3GF;EC8GA;IACE,aAAA;IACA,iBAAA;ED5GF;EC+GA;IACE,aAAA;IACA,eAAA;ED7GF;AACF;ACgHA;EACE,WAAA;AD9GF;;ACiHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AD9GF;;ACiHA;EACE,YAAA;AD9GF;;ACiHA;EACE,cAAA;AD9GF;;ACiHA;EACE,iDAAA;AD9GF;;ACiHA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AD9GF;;ACiHA;EACE,YAAA;AD9GF;;ACoHM;EACE,yBAAA;ADjHR;ACqHI;EACE,oCAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;ADnHN;ACqHM;EACE,eAAA;EACA,YAAA;ADnHR;ACwHM;EACE,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;ADtHR;;ACgIQ;EACE,oCAAA;EACA,YAAA;EACA,wBAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;AD7HV;ACkIY;EACE,YAAA;ADhId;ACqIY;EACE,YAAA;ADnId;ACyIU;EACE,yBAAA;ADvIZ;AC4IU;EACE,yBAAA;AD1IZ;;ACkJA;EACE,cAAA;AD/IF;;ACkJA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;AD/IF;;AC2JI;EACE,oCAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;ADxJN;AC2JQ;EACE,uBAAA;ADzJV;AC+JU;EACE,uBAAA;AD7JZ;;ACqKA;EACE,6CAAA;ADlKF;;ACqKA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;ADlKF;;ACqKA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ADlKF;;ACqKA,iBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EAGA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;ADlKF;;ACqKA;EACE,yBAAA;EACA,yBAAA;ADlKF;;ACqKA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,8CAAA;ADlKF;;ACqKA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EAGA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;ADlKF;;ACqKA;EACE,yBAAA;ADlKF;;ACqKA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;ADlKF;;ACqKA;EACE,YAAA;EAEA,gBAAA;EACA,mDAAA;EACA,8BAAA;ADnKF;;ACsKA;EACE,YAAA;EACA,sEAAA;EACA,mBAAA;EACA,+EAAA;ADnKF;;ACsKA;EACE,qBAAA;EACA,YAAA;ADnKF;;ACuKE;EACE,qBAAA;ADpKJ;;ACwKA,iBAAA;AAEA;EACE,wBAAA;ADtKF;;ACyKA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;ADtKF;;ACyKA;EACE,6BAAA;ADtKF;;ACyKA;EACE,iBAAA;ADtKF;;ACyKA;EACE,cAAA;ADtKF;;ACyKA;;;;EAIE,wCAAA;EAEA,mDAAA;EACA,iBAAA;EACA,yDAAA;EAAA,iDAAA;ADtKF;;ACyKA;EACE,wCAAA;ADtKF;;ACyKA;EACE,wCAAA;ADtKF;;ACyKA;EACE,yBAAA;ADtKF;;ACyKA;EACE,yBAAA;ADtKF;;ACyKA;EACE,yBAAA;ADtKF;;ACyKA;EACE,eAAA;EACA,wCAAA;ADtKF;;ACyKA;EACE,4BAAA;EACA,iDAAA;EACA,YAAA;EACA,wCAAA;ADtKF;;ACyKA;EAIE,uBAAA;ADzKF;;AC4KA;EAME,2BAAA;AD9KF;;ACiLA;EAEE,uBAAA;AD/KF;;ACkLA;EACE,gBAAA;EACA,gBAAA;AD/KF;;ACkLA;EACE,gBAAA;EACA,gBAAA;AD/KF;;ACkLA;;EAEE,6BAAA;EACA,6BAAA;EACA,gCAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;AD/KF;;ACkLA;;EAEE,0BAAA;AD/KF;;ACkLA;EACE,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;AD/KF;;ACkLA;EACE,6BAAA;EACA,sCAAA;EACA,4BAAA;AD/KF;;ACkLA;EACE,UAAA;AD/KF;;ACkLA;EACE,sBAAA;EACA,mBAAA;AD/KF;;ACkLA;EACE,sBAAA;EACA,+CAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AD/KF;;ACkLA;EACE,sCAAA;AD/KF;;ACkLA;EACE,wBAAA;AD/KF;;ACkLA;EACE;IACE,kCAAA;ED/KF;ECkLA;IACE,oCAAA;EDhLF;ECmLA;IACE,uCAAA;EDjLF;ECoLA;IACE,wCAAA;EDlLF;ECqLA;IACE,kCAAA;EDnLF;AACF;ACsLA;EAGE,cAAA;ADtLF;;ACyLA;EAIE,YAAA;ADzLF;;AC4LA;EAIE,YAAA;AD5LF;;AC+LA;EAIE,iBAAA;AD/LF;;ACkMA;EAEE,YAAA;ADhMF;;ACmMA;EAME,YAAA;EACA,mBAAA;ADrMF;;ACwMA;EAME,oCAAA;EACA,2BAAA;AD1MF;;AC6MA;EAIE,uBAAA;AD7MF;;ACgNA;EAIE,oCAAA;ADhNF;;ACmNA;EAGE,yBAAA;ADlNF;;ACqNA;EAGE,yBAAA;ADpNF;;ACuNA;EACE,oCAAA;ADpNF;;ACuNA;EACE,aAAA;ADpNF;;ACuNA,kCAAA;AACA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ADpNF;;ACuNA;EACE,aAAA;EACA,iBAAA;ADpNF;;ACuNA;EACE,mBAAA;EACA,iBAAA;ADpNF;;ACuNA;EACE,WAAA;EACA,aAAA;ADpNF;;ACuNA;EACE,sBAAA;EACA,kBAAA;ADpNF;;ACuNA;EACE,cAAA;ADpNF;;ACuNA;EACE,sBAAA;ADpNF;;ACuNA;EACE,6BAAA;EACA,sBAAA;ADpNF;;ACuNA;EACE,6BAAA;ADpNF;;ACuNA;EACE,4BAAA;ADpNF;;ACuNA;EACE,2BAAA;ADpNF;;ACuNA;EACE,sBAAA;ADpNF;;ACuNA,8CAAA;AACA;EACE,kBAAA;EACA,WAAA;ADpNF;;ACuNA;EACE,kBAAA;EACA,WAAA;ADpNF;;ACuNA,iEAAA;AACA;;EAEE,wBAAA;ADpNF;;ACuNA,gCAAA;AACA;EACE,qBAAA;ADpNF;;ACuNA;EACE,kBAAA;ADpNF;;ACuNA,wDAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EAEA,gCAAA;ADrNF;;ACwNA,uBAAA;AACA;EACE,mBAAA;ADrNF;;ACwNA,4BAAA;AACA;EACE,kBAAA;EACA,0BAAA;ADrNF;;ACwNA;EACE,kBAAA;ADrNF;;AE9kEA;EACE,yDAAA;EACA,YAAA;EACA,2BAAA,EAAA,qBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,sBAAA,EAAA,8DAAA;EACA,8BAAA;EACA,kDAAA;AFilEF;;AE9kEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AFilEF;;AE9kEA;EACE,wBAAA;AFilEF;;AE9kEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AFilEF;AE/kEE;EACE,WAAA;EACA,YAAA;AFilEJ;AE9kEI;EACE,YAAA;EACA,YAAA;AFglEN;;AE1kEE;EACE,kBAAA;AF6kEJ;AE5kEI;EACE,eAAA;EACA,iBAAA;AF8kEN;AE5kEI;EACE,eAAA;EACA,iBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AF8kEN;AE3kEE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AF6kEJ;AE3kEE;EACE,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,YAAA;EACA,kBAAA;AF6kEJ;AE5kEI;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AF8kEN;AE5kEI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AF8kEN;AE5kEI;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;AF8kEN;AE1kEE;EACE,kBAAA;AF4kEJ;AE3kEI;EACE,eAAA;EACA,iBAAA;AF6kEN;AE3kEI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AF6kEN;AE1kEE;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;AF4kEJ;;AExkEA;EACE,+BAAA;AF2kEF;;AExkEA;EACE,0CAAA;AF2kEF;;AEvkEE;EACE,YAAA;EACA,gBAAA;AF0kEJ;;AGtsEA;EACE;IACE,SAAA;EHysEF;EGvsEE;IACE,WAAA;IACA,YAAA;EHysEJ;EGrsEI;IACE,YAAA;IACA,YAAA;EHusEN;EGhsEI;IACE,eAAA;IACA,iBAAA;EHksEN;EG/rEI;IACE,eAAA;IACA,iBAAA;EHisEN;EG7rEE;IACE,YAAA;IACA,kBAAA;EH+rEJ;EG7rEI;IACE,eAAA;IACA,mBAAA;EH+rEN;EG5rEI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EH8rEN;EG3rEI;IACE,iBAAA;EH6rEN;EGxrEI;IACE,eAAA;EH0rEN;EGvrEI;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EHyrEN;EGrrEE;IACE,0BAAA;IACA,iBAAA;IACA,gBAAA;EHurEJ;EGnrEA;IACE,YAAA;EHqrEF;AACF;AGlrEA;EACE;IACE,YAAA;EHorEF;AACF;AGjrEA;EAGE;IACE,SAAA;EHirEF;EG/qEE;IACE,WAAA;IACA,YAAA;EHirEJ;EG7qEI;IACE,YAAA;IACA,YAAA;EH+qEN;EGxqEI;IACE,eAAA;IACA,iBAAA;EH0qEN;EGvqEI;IACE,eAAA;IACA,iBAAA;EHyqEN;EGrqEE;IACE,YAAA;IACA,kBAAA;EHuqEJ;EGrqEI;IACE,eAAA;IACA,mBAAA;EHuqEN;EGpqEI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EHsqEN;EGnqEI;IACE,iBAAA;EHqqEN;EGhqEI;IACE,eAAA;EHkqEN;EG/pEI;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EHiqEN;EG7pEE;IACE,0BAAA;IACA,iBAAA;IACA,gBAAA;EH+pEJ;EG3pEA;IACE,YAAA;EH6pEF;AACF;AG1pEA;EACE;IACE,YAAA;EH4pEF;AACF;AGzpEA;EACE;IACE,YAAA;EH2pEF;EGzpEA;IACE,WAAA;IACA,YAAA;EH2pEF;EGxpEA;IACE,eAAA;EH0pEF;EGvpEA;IACE,eAAA;EHypEF;AACF;AGtpEA;EACE;IACE,YAAA;EHwpEF;EGrpEA;IACE,WAAA;EHupEF;EGppEA;IACE,WAAA;EHspEF;EGnpEA;IACE,SAAA;IACA,mBAAA;EHqpEF;AACF;AGhpEA;EAEE;IACE,WAAA;EHipEF;EG/oEE;IACE,WAAA;EHipEJ;EG7oEA;IACE,iBAAA;EH+oEF;EG5oEA;IACE,WAAA;EH8oEF;EG3oEA;IACE,WAAA;EH6oEF;EG1oEA;IACE,WAAA;EH4oEF;EGzoEA;IACE,WAAA;EH2oEF;EGxoEA;IACE,YAAA;EH0oEF;EGvoEA;IACE,yBAAA;EHyoEF;EGtoEA;IACE,eAAA;EHwoEF;EGroEA;IACE,eAAA;EHuoEF;EGloEI;IACE,eAAA;IACA,iBAAA;EHooEN;EGjoEI;IACE,eAAA;IACA,iBAAA;EHmoEN;EG/nEE;IACE,0BAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;EHioEJ;EG9nEE;IACE,YAAA;IACA,kBAAA;EHgoEJ;EG9nEI;IACE,eAAA;IACA,mBAAA;EHgoEN;EG7nEI;IACE,eAAA;IACA,iBAAA;EH+nEN;EG5nEI;IACE,eAAA;EH8nEN;EGznEI;IACE,eAAA;EH2nEN;EGxnEI;IACE,eAAA;IACA,iBAAA;EH0nEN;EGtnEE;IACE,0BAAA;IACA,iBAAA;IACA,gBAAA;EHwnEJ;AACF;AGnnEA;EACE;IACE,YAAA;EHqnEF;AACF;AGlnEA;EACE;IACE,YAAA;EHonEF;AACF;AIh7EA;EACE,cAAA;AJk7EF;AIh7EE;EACE,gBAAA;AJk7EJ;AI/6EE;EACE,YAAA;EACA,gBAAA;AJi7EJ;;AI56EE;EACE,eAAA;EACA,sBAAA;AJ+6EJ;;AI36EA;;EAEE,aAAA;EACA,mBAAA;EACA,+BAAA;AJ86EF;AI36EI;;EACE,eAAA;AJ86EN;AI16EE;;;;EAEE,gBAAA;EACA,kBAAA;AJ86EJ;AI56EI;;;;EACE,qBAAA;AJi7EN;AI96EI;;;;;;;;EAEE,6CAAA;EACA,uBAAA;EACA,wCAAA;AJs7EN;AIp7EM;;;;;;;;EACE,aAAA;EACA,gBAAA;AJ67ER;AI17EM;;;;;;;;;;;;;;;;EAEE,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,cAAA;AJ08ER;AIx8EQ;;;;;;;;;;;;;;;;EACE,aAAA;AJy9EV;AIr9EM;;;;;;;;EACE,0BAAA;AJ89ER;AIx9EQ;;;;EACE,aAAA;EACA,iBAAA;AJ69EV;;AIt9EA;;EAEE,aAAA;EACA,mBAAA;EACA,yDAAA;AJy9EF;AIt9EI;;EACE,eAAA;AJy9EN;AIr9EE;;;;EAEE,gBAAA;EACA,kBAAA;AJy9EJ;AIv9EI;;;;EACE,qBAAA;AJ49EN;AIz9EI;;;;;;;;EAEE,6CAAA;EACA,uBAAA;EACA,wCAAA;AJi+EN;AI/9EM;;;;;;;;EACE,aAAA;EACA,gBAAA;AJw+ER;AIr+EM;;;;;;;;;;;;;;;;EAEE,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,cAAA;AJq/ER;AIn/EQ;;;;;;;;;;;;;;;;EACE,aAAA;AJogFV;AI7/EQ;;;;EACE,aAAA;EACA,iBAAA;AJkgFV;;AI3/EA;EACE,4BAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AJ8/EF;;AI3/EA;EACE,cAAA;AJ8/EF;;AI3/EA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AJ8/EF;;AI1/EA;EACE,yBAAA;EACA,mBAAA;AJ6/EF;;AI1/EA;EACE,yBAAA;EACA,sCAAA;EACA,sBAAA;EACA,+BAAA;AJ6/EF;;AI1/EA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AJ6/EF;;AI1/EA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AJ6/EF;;AI1/EA;EACE,yBAAA;EACA,oDAAA;EACA,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,+BAAA;AJ6/EF;;AI1/EA;EACE,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iCAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,uBAAA;AJ6/EF;;AIj8EA;EACE,QAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AJo8EF;;AIj8EA;EACE,8BAAA;EACA,mBAAA;AJo8EF;;AIj8EA;EACE,YAAA;AJo8EF;;AIj8EA;EACE,cAAA;AJo8EF;;AA3uFA;EACE,YAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kCAAA;EACA,kCAAA;EACA,wBAAA;AA8uFF","sourcesContent":["@import './assets/sass/custom.scss';\n@import './assets/sass/userManagement.scss';\n@import './assets/sass/responsive.scss';\n@import './assets/sass/filters.scss';\n\nhtml, body {\n  height: 100%;\n  background-color: black;\n  margin: 0;\n  overflow-x: hidden;\n  overflow: -moz-scrollbars-vertical;\n  font-family: 'Graphik', sans-serif;\n  /* overflow-y: scroll; */\n}",".bg_img_height {\n  height: 1500px;\n  margin-top: -340px;\n}\n\n.paragraphs_font {\n  font-family: \"Sora\", sans-serif;\n}\n\n.para_color {\n  color: #93a2b3;\n}\n\n.link-text {\n  color: #168de9;\n}\n\n.bg-dark-theme {\n  background-color: #000b15;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\n.custom-file-upload {\n  display: inline-block;\n  cursor: pointer;\n  color: wheat;\n  background-color: #ff8a00;\n}\n\n.custom-csv-upload {\n  display: inline-block;\n  cursor: pointer;\n  color: wheat;\n  background: linear-gradient(\n    90deg,\n    rgba(16, 171, 254, 1) 30%,\n    rgba(0, 115, 238, 1) 90%\n  );\n}\n\n// select {\n//   -webkit-appearance: none;\n//   -moz-appearance: none;\n//   appearance: none;\n//   background: transparent;\n//   background-image: url(\"../arrow_select.svg\");\n//   background-repeat: no-repeat;\n//   background-position-x: 95%;\n//   background-position-y: 55%;\n// }\n\n.language-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../small-arrow.svg\");\n  background-repeat: no-repeat;\n  background-position-x: 92%;\n  background-position-y: 15px;\n}\n\n.language-select-black-icon {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../down.png\");\n  background-repeat: no-repeat;\n  background-position-x: 95%;\n  background-position-y: 8px;\n}\n\n.gradient_button {\n  // background: linear-gradient(\n  //   90deg,\n  //   rgba(16, 171, 254, 1) 30%,\n  //   rgba(0, 115, 238, 1) 90%\n  // );\n  background: #0073ee;\n}\n\n.greetings {\n  border-left: 2px solid;\n  border-image: linear-gradient(\n      to bottom,\n      rgba(16, 171, 254, 1),\n      rgba(0, 115, 238, 1)\n    )\n    1 100%;\n}\n\n.text_gold {\n  color: #e07900;\n}\n\n.button_gold {\n  background-color: #e07900;\n}\n\n.select-box {\n  height: 50px;\n}\n\n.gradient_text {\n  background: linear-gradient(to right, #10abfe 1%, #0073ee 99%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.lets_go_text {\n  background: linear-gradient(to right, #10abfe 12%, #0073ee 40%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.opacity_blue {\n  background-color: #111f2c;\n}\n\n.field_bg-blue {\n  background-color: #000b15;\n}\n\n.inputfield {\n  font-weight: 400;\n  width: 100%;\n  height: 58px;\n  font-family: \"inter\", sans-serif;\n  background-color: #000b15;\n  border: 1px solid #1e293b;\n  border-radius: 6px;\n}\n\n.was-validated {\n  border: 1px solid red !important;\n}\n\n.was-validated::-webkit-input-placeholder {\n  color: red;\n}\n\n.border {\n  border: 1px solid #1e293b;\n}\n\n.button-border {\n  border: 1px solid #1e293b;\n}\n\n.text-area {\n  border: 1px solid #1e293b;\n}\n\n.PhoneInput {\n  height: 45px;\n  width: 100%;\n  font-size: 16px;\n  background-color: #000b15;\n  border: 1px solid #1e293b;\n}\n\n.PhoneInputInput {\n  height: 43px;\n  width: 100%;\n  background-color: #000b15 !important;\n  outline: none;\n  color: white;\n}\n\n.PhoneInputCountry {\n  font-size: 18px;\n  border-right: 1px solid #1e293b;\n  padding-right: 10px;\n  padding-left: 10px;\n}\n\n.PhoneInputCountryIconUnicode,\n.PhoneInputCountryIcon {\n  color: white;\n}\n\n.PhoneInputCountrySelectArrow {\n  color: white;\n}\n\n.input_select {\n  width: 70%;\n  height: 30px;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  display: block;\n  background: url(\"../call.svg\") no-repeat;\n  width: 20px;\n  height: 20px;\n  border-width: thin;\n  margin-top: 8px;\n}\n\n.landing-screen {\n  background: url(\"../landing_page_bg.png\") no-repeat;\n  width: 100%;\n  height: 702px;\n  display: block;\n  background-size: cover;\n}\n\n.dashboard_card_main {\n  display: flex;\n  height: 152px;\n  border-radius: 2px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.dashboard_card_main:hover {\n  transform: translate(0, -8px);\n  box-shadow: 0 0 11px rgba(35, 87, 160, 0.7);\n}\n\n.dashboard_card_bg_color {\n  color: white;\n  background-color: #091724;\n}\n\n.dashboard_card_inner_right {\n  padding: 0px 0px 0px 20px;\n}\n\n.card_title {\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.card_description {\n  font-size: 13px;\n}\n\n.user_registration_inner {\n  display: flex;\n}\n\n.show {\n  display: block;\n}\n\n.hide {\n  display: none;\n}\n\n.left_bordered {\n  height: 50px;\n  border-left: 1px solid #1e293b;\n  margin-left: 15px;\n}\n\n.tabs_right {\n  padding-left: 30px;\n}\n\n.right-position {\n  right: -760px;\n}\n\n.w-99 {\n  width: 75%;\n}\n\n.w-200 {\n  width: 500px;\n  height: auto;\n}\n\n.animated {\n  -webkit-animation: rotate 550s normal linear infinite;\n  animation: rotate 550s normal linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate3d(0, 0, 1, 0deg);\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n\n  25% {\n    -webkit-transform: rotate3d(0, 0, 1, 90deg);\n    transform: rotate3d(0, 0, 1, 90deg);\n  }\n\n  50% {\n    -webkit-transform: rotate3d(0, 0, 1, 180deg);\n    transform: rotate3d(0, 0, 1, 180deg);\n  }\n\n  75% {\n    -webkit-transform: rotate3d(0, 0, 1, 270deg);\n    transform: rotate3d(0, 0, 1, 270deg);\n  }\n\n  100% {\n    -webkit-transform: rotate3d(0, 0, 1, 360deg);\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n\n.bg_color {\n  background-color: #00080f;\n}\n\n.ant-table-wrapper .ant-pagination .ant-pagination-item {\n  margin: 0 4px !important;\n  background-color: transparent !important;\n  font-family: \"Sora\", sans-serif;\n}\n\n.ant-table-wrapper .ant-pagination .ant-pagination-item-active {\n  font-weight: bold !important;\n  border: none !important;\n  border-bottom: 2px solid #0073ee !important;\n  border-radius: 0px;\n  height: 46px;\n  padding-top: 8px;\n  background-color: transparent !important;\n}\n\n.ant-pagination-prev,\n.ant-pagination-next {\n  font-size: 14px !important;\n  margin: 0 44px !important;\n}\n\n.dark-theme .ant-pagination-item-link,\n.dark-theme .ant-pagination-prev,\n.dark-theme .ant-pagination-next {\n  background-color: #000b15 !important;\n}\n\n.light-theme .ant-pagination-item-link,\n.light-theme .ant-pagination-prev,\n.light-theme .ant-pagination-next {\n  background-color: #fff !important;\n}\n\n.table_bg_color_black_th th {\n  background-color: #000b15 !important;\n  color: white !important;\n  font-family: \"Graphik\", sans-serif !important;\n  font-size: 16px !important;\n  padding: 16.5px !important;\n  line-height: 100% !important;\n}\n\n.table_bg_color_black_td td {\n  background-color: #000b15 !important;\n  color: white !important;\n  font-family: \"Sora\", sans-serif !important;\n  font-size: 16px !important;\n  padding: 15.5px 16.5px !important;\n  line-height: 100% !important;\n}\n\n.table_rows_black .ant-table-row > td {\n  background-color: #091724 !important;\n  color: white !important;\n}\n\n.table_rows_black .ant-table-row > td {\n  background-color: #000b15 !important;\n  border-top: 1px solid #1e293b;\n  background-color: #000b15 !important;\n  border-top: 1px solid #1e293b;\n  color: white !important;\n}\n\n.table_bg_color_white_th th {\n  background-color: #ffffff !important;\n  color: #1d242e !important;\n  font-family: \"Graphik\", sans-serif !important;\n  font-size: 16px !important;\n  padding: 16.5px !important;\n  line-height: 100% !important;\n}\n\n.table_bg_color_white_td td {\n  background-color: #ffffff !important;\n  color: #1d242e !important;\n  font-family: \"Sora\", sans-serif !important;\n  font-size: 16px !important;\n  padding: 15.5px 16.5px !important;\n  line-height: 100% !important;\n}\n\n.table_rows_white .ant-table-row > td {\n  background-color: white !important;\n  color: black !important;\n  border-bottom: 1px solid black !important;\n}\n\n.table_rows_black .ant-table-placeholder > td {\n  background-color: #091724 !important;\n}\n\n.table_rows_black .ant-table-placeholder > td .ant-empty-description {\n  color: white !important;\n}\n\n.tabs_bg-white {\n  background-color: #e3f2fe;\n  color: #0073ee;\n}\n\n.bg-for-light {\n  background-color: #fff;\n}\n\n.bg-import-button {\n  background-color: #1e3a2c;\n}\n\n.bg-add-new-user-button {\n  background-color: #5a4123;\n}\n\n.bg-add-new-company-button {\n  background-color: #0c2541;\n}\n\n.bg-light-blue-button {\n  background-color: #0073ee;\n}\n\n.bg-light-green-button {\n  background-color: #20744a;\n}\n\n.modal-container-overlay {\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 300;\n}\n\n.summary-container {\n  background-color: rgba(0, 11, 21, 0.7);\n}\n\n.card-board {\n  border: 1px solid #e5e9eb;\n}\n\n.border-right-only {\n  border-right: 1px solid #e5e9eb;\n}\n\n.border-dashed {\n  border: 1px dashed #e5e9eb;\n}\n\n.landign-screen-text-animated {\n  background: linear-gradient(\n    to right,\n    rgba(16, 171, 254, 1) 20%,\n    rgba(0, 115, 238, 1) 30%,\n    rgba(16, 171, 254, 1) 70%,\n    rgba(0, 115, 238, 1) 80%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-size: 300% auto;\n  animation: textShine 1s ease-in-out infinite alternate;\n}\n\n@keyframes textShine {\n  0% {\n    background-position: 0% 20%;\n  }\n\n  50% {\n    background-position: 0% 40%;\n  }\n\n  100% {\n    background-position: 100% 0%;\n  }\n}\n\n.button-dark {\n  background-color: #091724;\n}\n\n.input_field_main_password {\n  position: relative;\n}\n\n.show_password {\n  right: 10px;\n}\n\ninput::-webkit-input-placeholder {\n  color: #9e9e9e;\n}\n\n.box-shadow-sign-in {\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);\n  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);\n  -moz-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);\n}\n\n.input_field_main_textarea textarea {\n  background: #000b15;\n  border: 1px solid #1e293b;\n  outline: none;\n  color: white;\n  resize: none;\n}\n\n.box_1 {\n  width: 55px;\n  height: 0px;\n}\n\ninput[type=\"checkbox\"].switch_1 {\n  font-size: 16px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  width: 2.8em;\n  height: 20px;\n  background: #ddd;\n  border-radius: 3em;\n  position: relative;\n  cursor: pointer;\n  outline: none;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\ninput[type=\"checkbox\"].switch_1:checked {\n  background: #0ebeff;\n}\n\ninput[type=\"checkbox\"].switch_1:after {\n  position: absolute;\n  content: \"\";\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #fff;\n  -webkit-box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n  -webkit-transform: scale(0.7);\n  transform: scale(0.7);\n  left: -3px;\n  top: -3.4px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\ninput[type=\"checkbox\"].switch_1:checked:after {\n  left: calc(100% - 1.4em);\n}\n\n.checkBox_value_color {\n  color: #e92f46;\n}\n\n.multi_select_field.ant-select-selector {\n  outline: none;\n  color: white;\n  border: none !important;\n  padding: 8px 0px !important;\n  padding-left: 5px !important;\n}\n\n.multi_select_field.ant-select-arrow,\n.multi_select_field.ant-select-clear {\n  color: white !important;\n}\n\n.multi_select_field.ant-select-selection-item {\n  background-color: #0073ee !important;\n}\n\n.multi_select_field.ant-select-selection-item-remove {\n  color: white !important;\n}\n\n.multi_select_field.ant-select-selection-placeholder {\n  color: #9e9e9e !important;\n}\n\n.w-35 {\n  width: 35.666667%;\n}\n\n.w-49 {\n  width: 49%;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px rgb(32, 32, 32);\n  background: #01111f;\n  /* border-radius: 10px; */\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #0073ee !important;\n  /* border-radius: 10px; */\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #0073ee;\n}\n\n/* Horizontal scrollbar */\n::-webkit-scrollbar:horizontal {\n  height: 7px;\n  /* height of horizontal scrollbar */\n}\n\n/* Track for horizontal scrollbar */\n::-webkit-scrollbar-track:horizontal {\n  background: #01111f;\n  /* color of the track for horizontal scrollbar */\n}\n\n/* Handle for horizontal scrollbar */\n::-webkit-scrollbar-thumb:horizontal {\n  background: #0073ee;\n  /* color of the thumb for horizontal scrollbar */\n}\n\n/* Handle on hover for horizontal scrollbar */\n::-webkit-scrollbar-thumb:horizontal:hover {\n  background: #0056b3;\n  /* color of the thumb on hover for horizontal scrollbar */\n}\n\n:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before,\n:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > td:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before {\n  background: #0073ee;\n}\n\n.ant-table-wrapper.light-theme {\n  border: 1px solid #e5e9eb !important;\n  /* Border color for light theme */\n  border-radius: 8px !important;\n  /* Optional: Add border radius for rounded corners */\n  overflow: hidden !important;\n  /* Ensure content does not overflow the border */\n}\n\n/* Dark theme: Add border around the entire table */\n.ant-table-wrapper.dark-theme {\n  border: 1px solid #1e293b !important;\n  /* Border color for dark theme */\n  border-radius: 8px !important;\n  /* Optional: Add border radius for rounded corners */\n  overflow: hidden !important;\n}\n\n:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before,\n:where(.css-dev-only-do-not-override-2rgkd4).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > td:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before {\n  width: 0px !important;\n}\n\n/* .draggable-table .ant-spin-nested-loading .ant-spin-container .ant-table .ant-table-container .ant-table-content .ant-table-thead .ant-table-cell{\n  background: white!important;\n} */\n.ant-table-expanded-row .ant-table-cell {\n  padding: 0px !important;\n}\n\n.tabs-bg {\n  /* background-color: rgb(229, 242, 255); */\n  background-color: #fcfcfc;\n}\n\n.active-tab {\n  border-bottom: 2px solid #0073ee;\n}\n\n.tab-pannel {\n  border-left: 2px solid #0073ee;\n}\n\ninput[type=\"checkbox\"].switch_11 {\n  font-size: 12px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  width: 3em;\n  height: 1.5em;\n  background: #ddd;\n  border-radius: 3em;\n  position: relative;\n  cursor: pointer;\n  outline: none;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\ninput[type=\"checkbox\"].switch_11:checked {\n  background: #11c700;\n}\n\ninput[type=\"checkbox\"].switch_11:after {\n  position: absolute;\n  content: \"\";\n  width: 1.5em;\n  height: 1.5em;\n  border-radius: 50%;\n  background: #fff;\n  -webkit-box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);\n  -webkit-transform: scale(0.7);\n  transform: scale(0.7);\n  left: 0;\n  top: 0;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\ninput[type=\"checkbox\"].switch_11:checked:after {\n  left: calc(100% - 1.5em);\n}\n\n.z-700 {\n  z-index: 700;\n}\n\n.z-800 {\n  z-index: 800;\n}\n\n.side-navbar {\n  width: 0;\n  overflow-x: hidden;\n}\n\n.width-250 {\n  width: 300px;\n  animation: widthIncreasae 0.5s ease-in-out;\n}\n\n@keyframes widthIncreasae {\n  0% {\n    width: 0px;\n  }\n\n  100% {\n    background-position: 300px;\n  }\n}\n\n.side-navbar a {\n  transition: 1s;\n}\n\n.custom-h-10 {\n  height: 10%;\n}\n\n.custom-h-90 {\n  height: 90%;\n}\n\n.f-18 {\n  font-size: 18px;\n}\n\n.tabs-input-border {\n  border: 1px solid #e6e6e6;\n  width: 300px;\n  outline: none;\n}\n\n.tabs-select-border {\n  border: 1px solid #e6e6e6;\n  width: 300px;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../down.png\");\n  background-repeat: no-repeat;\n  background-position-x: 97%;\n  background-position-y: 10px;\n}\n\n.opt-input {\n  border: 1px solid #8b9caa;\n  width: 200px;\n  outline: none;\n}\n\n.cond-select-icon {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../down.png\");\n  background-repeat: no-repeat;\n  background-position-x: 95%;\n  background-position-y: 7px;\n}\n\n/* .ant-table-pagination{\n    width: 30%;\n    margin: 15px auto!important;\n  } */\n.ant-pagination li {\n  background-color: white !important;\n}\n\n.ant-pagination-options-size-changer {\n  border: 1px solid #8b9caa !important;\n}\n\n.multi_select_field.ant-pagination-options-size-changer .ant-select-selector {\n  background-color: white !important;\n}\n\n.multi_select_field.ant-pagination-options-size-changer\n  .ant-select-selector\n  .ant-select-selection-item {\n  background-color: white !important;\n}\n\n.side-navbar-item:hover {\n  background-color: #111f2c;\n}\n\n.uplaod-scvicon {\n  animation: MoveUpDown 5s linear infinite;\n}\n\n@keyframes MoveUpDown {\n  0%,\n  100% {\n    transform: translateY(-0.5rem);\n  }\n\n  50% {\n    transform: translateY(1ch);\n  }\n}\n\n.heading-light-gray {\n  color: #9e9e9e;\n}\n\n// select:invalid,\n// select option[value=\"\"] {\n//   color: #999999;\n//   font-family: \"Sora\", sans-serif;\n// }\n\n.multi_select_field.ant-select-selection-placeholder {\n  color: #999999 !important;\n  font-family: \"Sora\", sans-serif !important;\n  font-size: 16px !important;\n}\n\n.mrt-2 {\n  margin-top: -2px;\n}\n\n.row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.pl-10 {\n  padding-left: 10px;\n}\n\n.w-11 {\n  width: 11%;\n}\n\n.inputfield-white {\n  font-weight: 300;\n  width: 100%;\n  height: 45px;\n  font-family: \"Sora\", sans-serif;\n}\n\n.test:after {\n  content: \"\\2807\";\n  font-size: 30px;\n}\n\n.mobile-view {\n  border: 4px solid black;\n  border-radius: 8px;\n}\n\n.golden-view {\n  border: 4px solid rgb(114, 114, 113);\n  border-radius: 6px;\n}\n\n.head-border {\n  border-top-left-radius: 2px 2px;\n  border-top-right-radius: 2px 2px;\n}\n\n.activity-input-white {\n  font-weight: 300;\n  width: 100%;\n  height: 30px;\n  font-family: \"Sora\", sans-serif;\n}\n\n.acitivity-form-inputblack {\n  font-weight: 300;\n  width: 100%;\n  height: 30px;\n  font-family: \"Sora\", sans-serif;\n  background-color: #000b15;\n  border: 1px solid #1e293b;\n}\n\n.activiy-select-black {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../down.png\");\n  background-repeat: no-repeat;\n  background-position-x: 95%;\n  background-position-y: 7px;\n}\n\n.activiy-select-gray {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"../sel_gray.png\");\n  background-repeat: no-repeat;\n  background-position-x: 95%;\n  background-position-y: 9px;\n}\n\n:where(.css-dev-only-do-not-override-2rgkd4).ant-collapse\n  .ant-collapse-content\n  > .ant-collapse-content-box {\n  padding: 8px 0px 0px 0px;\n}\n\n.ant-collapse-expand-icon {\n  margin-top: 5px;\n}\n\n.activity-mddl {\n  padding: 0px;\n}\n\n.multi_select_field.activity-mddl .ant-select-selector {\n  background-color: white !important;\n  outline: none;\n  color: black;\n  border: none !important;\n  padding: 0px 0px !important;\n  padding-left: 0px !important;\n  outline: none !important;\n}\n\n.edit-button {\n  background-color: #f6f6f6;\n}\n\n.boarder-description {\n  border-top: 1px solid #e6e6e6;\n  border-bottom: 1px solid #e6e6e6;\n  border-left: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(3) p:nth-child(1) {\n  border-right: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(6) p:nth-child(1) {\n  border-right: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(1) p:nth-child(2) {\n  border-right: 1px solid #e6e6e6;\n  border-left: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(3) p:nth-child(2) {\n  border-right: 1px solid #e6e6e6;\n  border-left: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(5) p:nth-child(2) {\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(4) p:nth-child(2) {\n  border-right: 1px solid #e6e6e6;\n  border-left: 1px solid #e6e6e6;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.org-details div:nth-child(6) p:nth-child(2) {\n  border-right: 1px solid #e6e6e6;\n  border-left: 1px solid #e6e6e6;\n  border-bottom: 1px solid #e6e6e6;\n}\n\n.site-form div:nth-child(5) {\n  width: 100%;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #091724 !important;\n}\n\n.light-theme\n  .css-dev-only-do-not-override-2rgkd4.ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td {\n  border-bottom: none !important;\n}\n\n.light-theme\n  .css-dev-only-do-not-override-2rgkd4.ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td {\n  border-bottom: 1px solid #e5e9eb !important;\n  /* Light theme border color */\n}\n\n.dark-theme\n  .css-dev-only-do-not-override-2rgkd4.ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td {\n  border-bottom: 1px solid #1e293b !important;\n  /* Dark theme border color */\n}\n\n.icon-white {\n  color: white;\n}\n\n.ant-descriptions-item-label {\n  color: white;\n  /* border-width: 2px; */\n}\n\n.ant-descriptions {\n  background-color: white;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n  border-bottom: none;\n}\n\n.ant-descriptions-bordered {\n  color: yellow;\n}\n\n.bordered-descriptions-content .ant-descriptions-item-content {\n  /* padding: 8px 24px;\n  width: 100%;\n  height: 60px;\n  top: 0 !important;\n  bottom: 0 !important;\n  background-color: #091724;\n  color: white;\n  border: 1px solid #1E293B;\n  box-sizing: border-box;\n  margin-bottom: -17px !important; */\n\n  padding-left: 24px;\n  width: 100%;\n  height: 100%;\n  height: 100%;\n  top: 120px;\n}\n\n.bordered-descriptions-label .ant-descriptions-item-label {\n  /* border: 4px solid #1E293B;\n  border-width: 4px solid;\n  /* padding-top: 8px; */\n  /* padding-left: 24px; */\n  /* padding: 4px 24px;\n  border-radius: 2px;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  opacity: 1;\n  color: white;\n  height: 60px;\n  background-color: #091724;\n  margin-bottom: -17px !important; */\n  border: 1px solid #e8e8e8;\n  /* Add border inside each description item */\n  border-width: 4px solid;\n  padding-top: 8px;\n  padding-left: 24px;\n  width: 100%;\n  height: 60px;\n  background-color: #f0f0f0;\n  top: 20px;\n  color: #000000;\n}\n\n.ant-descriptions-row {\n  padding: 0;\n  margin: 0;\n}\n\n.multi_select_field.ant-select-focused {\n  outline: none !important;\n}\n\n.move-to-right {\n  transform: translateX(18px);\n  transition: linear 0.2s;\n}\n\n.move-to-left {\n  transform: translateX(-3px);\n  transition: linear 0.2s;\n}\n\n.edit-button-dark {\n  background-color: #0073ee !important;\n}\n\n.view-button-dark {\n  background-color: #318ce7 !important;\n}\n\n.z-index-breads {\n  z-index: 99999 !important;\n}\n\n.select_box_field {\n  width: 100%;\n  height: 45px;\n  border-radius: 2px;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  // color: #ffffff73;\n  // background-color: #000b15;\n}\n\n.select_bg {\n  background-color: #000b15;\n}\n\n.login_inputs {\n  width: 525px;\n}\n\n.dark_toogle {\n  width: 270px;\n}\n\n.bread-board {\n  border: 1px solid #e6e6e6;\n  border-left: none;\n}\n\n.dashboard_bread_bg_color {\n  color: white;\n  background-color: #091724;\n  border-left: none;\n}\n\n.w-350 {\n  width: 350px;\n}\n\n.w-53 {\n  width: 53%;\n}\n\n.w-30 {\n  width: 30%;\n}\n\n.reporting_wrapper {\n  display: \"flex\";\n  justify-content: \"space-between\";\n  // marginBottom: 16;\n}\n\n.access_deneid_main {\n  background-color: white;\n  height: 100%;\n  width: 100%;\n}\n\n.access_deneid_h1 {\n  font-family: \"Graphik\", sans-serif !important;\n  font-size: 65px !important;\n  color: \"#1D242E\";\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.loader {\n  border: 5px solid #eaf0f6;\n  border-radius: 100%;\n  border-top: 5px solid #0073ee;\n  animation: spinner 3s linear infinite;\n  width: 75px;\n  height: 75px;\n\n  &.lg {\n    width: 75px;\n    height: 75px;\n  }\n\n  &.sm {\n    width: 35px;\n    height: 35px;\n  }\n}\n\n.animated-text {\n  color: #0073ee;\n  font-size: 20px;\n  margin-left: 10px;\n}\n\n.loading-dots-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-dots {\n  text-align: center;\n  font-size: 20px;\n  margin-left: 5px;\n}\n\n.dot {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  background-color: #0073ee;\n  border-radius: 50%;\n  margin-right: 8px;\n  opacity: 0;\n  animation: fadeIn 1s infinite linear;\n}\n\n.dot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.5s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 1s;\n}\n\n.map_toggle_button {\n  width: 122px;\n  height: 40px;\n  border-radius: 4px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  display: flex;\n  align-items: center;\n\n  .single_button {\n    width: 56px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.reporting_tooltip_content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n\n  h4 {\n    color: #1d242e;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 600;\n    font-family: \"Graphik\", sans-serif;\n  }\n\n  h5 {\n    color: #6f767e;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    font-family: \"Sora\", sans-serif;\n  }\n}\n\n.salesPitchDownloadButton {\n  width: 366px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background-color: #d7eeff;\n  color: #0073ee;\n  border-radius: 8px;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  margin: 16px 0px;\n}\n\n.sales_pitch_downlaod_table {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.csvButtonRepoting {\n  font-family: \"Graphik\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  height: 40px;\n  width: 133px;\n  border: 1px solid #dde2e4;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.selectColumnsButton {\n  font-family: \"Graphik\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  height: 40px;\n  width: 121px;\n  border: 1px solid #dde2e4;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.csvButtonRepoting.disabled,\n.selectColumnsButton.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  filter: grayscale(100%);\n}\n\n.text-button {\n  border: none;\n  background: none;\n  color: #333;\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: underline;\n  padding: 0;\n  margin: 0;\n}\n\n.ant-table-measure-row {\n  display: none;\n  /* Hide the measure row */\n}\n\n.link_button {\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  color: #0073ee;\n  text-decoration: underline;\n  background-color: transparent;\n  border: none;\n  padding: 10px;\n}\n\n.link_button:hover {\n  color: #0053ce;\n}\n\n.group-container-selected-fields {\n  border: 2px dashed #1d242e;\n  position: relative;\n  gap: 8px;\n  margin-top: 32px;\n  background-color: transparent;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  padding: 16px;\n}\n\n.selected-field {\n  height: fit-content;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  transition: all 0.3s ease;\n  background-color: rgba(9, 88, 224, 0.7);\n  border-radius: 8px;\n  position: relative;\n  color: #ffffff;\n}\n\n.sales-pitch-form-main-container {\n  background: #fff;\n  border: 1px solid #e6e6e6;\n  padding: 24px 20px 0px 20px;\n}\n\n.sales-pitch-form-buttons {\n  margin-top: 32px;\n  display: flex;\n  justify-content: flex-start;\n  gap: 16px;\n}\n\n.border-radius-input-field {\n  border-radius: 4px !important;\n  transition: box-shadow 0.3s;\n}\n\n.border-radius-input-field:focus {\n  box-shadow: 0px 0px 0px 3px rgba(0, 115, 238, 0.22);\n}\n\n.add_keyword_button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-self: center;\n  gap: 6px;\n  font-size: 16px;\n  font-family: \"Sora\", sans-serif;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.save_keyword_button {\n  background-color: #0073ee;\n  padding: 8px 69px;\n  color: #ffffff;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 4px;\n}\n\n.cancle_keyword_button {\n  padding: 8px 69px;\n  color: rgba(255, 255, 255, 0.5);\n  background-color: #091724;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid #091724;\n}\n\n/* Custom styles for Rating component */\n.rating-container {\n  margin-bottom: 1rem;\n}\n\n.rating-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.stars {\n  display: flex;\n}\n\n.star {\n  font-size: 2rem;\n  color: #ccc;\n  cursor: pointer;\n  position: relative;\n}\n\n.star.filled {\n  color: gold;\n}\n\n.star.half-filled::before {\n  content: \"★\";\n  position: absolute;\n  left: 0;\n  width: 50%;\n  overflow: hidden;\n  color: gold;\n}\n\n.single-Tab {\n  border-bottom: 2px solid #0073ee;\n}\n\n.scrollable {\n  height: 100%;\n  overflow-y: scroll;\n  border: 1px solid black;\n  padding: 10px;\n  margin-right: 10px;\n  right: 0;\n  top: 0;\n  transition: right 0.3s ease-in-out !important;\n}\n\n.user-avatar {\n  height: 100px;\n  width: 100px;\n}\n\n.upload-user-image-container {\n  width: 88px;\n  height: 88px;\n  background-color: #1d242e;\n  border-radius: 9999px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.upload-user-image {\n  width: 128px;\n  height: 128px;\n}\n\n.image-conatiner {\n  width: 88px;\n  height: 88px;\n  position: relative;\n  border-radius: 50%;\n}\n\n.image-conatiner .user-image {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n}\n\n.delete-image {\n  width: 115px;\n  height: 115px;\n  z-index: 9999;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.attedace-image {\n  width: 125px;\n  height: 125px;\n  position: relative;\n  border-radius: 4px;\n}\n\n.image-input-info {\n  width: 70%;\n}\n\n.calling-button {\n  color: white;\n  width: 290px;\n  height: 40px;\n  background-color: #00835b;\n\n  margin-left: 20px !important;\n  padding-bottom: 5px;\n  padding-top: 15px;\n  // padding: 15px;\n}\n\n.end-calling {\n  color: white;\n  width: 290px;\n  height: 40px;\n  background-color: #e71d36;\n  // padding-right: 10px;\n  // padding-left: 10px;\n  // padding: 15px;\n  margin-left: 20px !important;\n  padding-bottom: 5px;\n  padding-top: 15px;\n}\n\n.text-line {\n  stroke-dasharray: 500;\n  stroke-dashoffset: 500;\n  animation:\n    dash 3s linear infinite,\n    filling 3s ease-in infinite;\n  font-size: 80px;\n}\n\n.text-line text {\n  font-family: Helvetica, Arial, sans-serif;\n  font-weight: normal;\n  font-style: normal;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes filling {\n  0% {\n    fill: #10abfe;\n    fill-opacity: 0;\n  }\n\n  70% {\n    fill: transparent;\n    fill-opacity: 0.3;\n  }\n\n  85% {\n    fill: #0073ee;\n    fill-opacity: 0.8;\n  }\n\n  100% {\n    fill: #0073ee;\n    fill-opacity: 1;\n  }\n}\n\n.w-siderbar {\n  width: 64px;\n}\n\n.icon-container {\n  width: 66px;\n  height: 66px;\n  border-radius: 50%;\n  background-color: #1d242e;\n}\n\n.w-880 {\n  width: 880px;\n}\n\n.title-content {\n  color: #667085;\n}\n\n.modal-title-container {\n  border-bottom: 1px solid rgba(228, 228, 228, 0.2);\n}\n\n.instructions-list {\n  color: #667085;\n  font-size: 12px;\n  padding-left: 20px;\n}\n\n.w-400 {\n  width: 400px;\n}\n\n.input-field-container {\n  .group {\n    > div[data-focus=\"true\"] {\n      > label {\n        color: #52525b !important;\n      }\n    }\n\n    div:first-child {\n      background-color: #000b15 !important;\n      color: white;\n      border: 1px solid #1e293b;\n      height: 58px;\n      border-radius: 6px;\n\n      label {\n        font-size: 14px;\n        color: white;\n      }\n    }\n\n    div:nth-child(2) {\n      input {\n        background-color: #000b15;\n        color: white !important;\n        outline: none;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n.select_field_container {\n  div:first-child {\n    .group {\n      div:nth-child(2) {\n        button {\n          background-color: #000b15 !important;\n          color: white;\n          outline: none !important;\n          font-size: 14px !important;\n          border: 1px solid #1e293b;\n          border-radius: 6px !important;\n          height: 58px !important;\n        }\n\n        button {\n          div:nth-child(2) {\n            span {\n              color: white;\n            }\n          }\n\n          div:nth-child(1) {\n            span {\n              color: white;\n            }\n          }\n        }\n\n        > button {\n          > label {\n            color: #ecedee !important;\n          }\n        }\n\n        > button[data-focus=\"true\"] {\n          > label {\n            color: #52525b !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.field-label {\n  color: #ecedee;\n}\n\n.field-focused {\n  color: #52525b;\n  border: 1px solid #0073ee;\n  border-radius: 6px;\n\n  // font-size: 12px !important;\n}\n\n// .field-focused > div {\n//   --tw-ring-offset-width : 0px\n//   // font-size: 12px !important;\n// }\n\n.input-Datefield-container {\n  > :first-child {\n    > :first-child {\n      background-color: #000b15 !important;\n      color: white;\n      border: 1px solid #1e293b;\n      height: 58px !important;\n      border-radius: 6px !important;\n\n      > :first-child {\n        svg {\n          border: none !important;\n        }\n      }\n\n      > :nth-child(2) {\n        > :first-child {\n          div {\n            color: white !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.font-graphik-important {\n  font-family: \"Graphik\", sans-serif !important;\n}\n\n.ant-table-thead > tr > th.custom-header {\n  background-color: #e3f2fe !important;\n  color: #0073ee !important;\n  position: relative;\n}\n\n.ant-table-thead > tr > th.custom-header > div {\n  background-color: #e3f2fe;\n  color: #0073ee !important;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* Custom Table */\n.custom-checkbox {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid #e5e9eb;\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n}\n\n.custom-checkbox:checked {\n  background-color: #1890ff;\n  border: 1px solid #1890ff;\n}\n\n.custom-checkbox:checked::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 43%;\n  width: 6px;\n  height: 10px;\n  border-right: 2px solid white;\n  border-bottom: 2px solid white;\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.custom-checkbox-all {\n  position: relative;\n  width: 16px;\n  height: 16px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 1px solid #e5e9eb;\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n}\n\n.custom-checkbox-all:checked {\n  background-color: #1890ff;\n}\n\n.custom-checkbox-all:checked::before {\n  content: \"\";\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  border: 3px solid white;\n}\n\n.accordionClass {\n  height: 56px;\n  //max-height: 56px; /* Set the same initial max-height */\n  overflow: hidden;\n  /* Hide any overflowing content during transition */\n  transition: max-height 2s ease;\n}\n\n.accordionClass[data-open=\"true\"] {\n  height: auto;\n  /* Set a large enough max-height to accommodate the expanded content */\n  margin-bottom: 10px;\n  /* No need to specify transition again, it's inherited from the initial state */\n}\n\n.accordionClass h2 > button {\n  padding: 0 !important;\n  height: 56px;\n}\n\n.accordionClass[data-open=\"true\"] {\n  section > div.py-2 {\n    padding: 0 !important;\n  }\n}\n\n/* Custom Table */\n\n.outline-none {\n  outline: none !important;\n}\n\n.outline-input-custom {\n  background-color: #000b15;\n  border: 1px solid #1e293b;\n  border-radius: 5px;\n  color: #ffffff;\n}\n\n.outline-input-custom > div {\n  background-color: transparent;\n}\n\n.calender-icon > div > div > button {\n  margin-top: -16px;\n}\n\n.calender-icon > div > span {\n  color: #ffffff;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-text-fill-color: #fff !important;\n  -webkit-box-shadow: 0 0 0px 1000px #000b15 inset !important;\n  box-shadow: 0 0 0px 1000px #000b15 inset !important;\n  caret-color: #fff;\n  transition: background-color 9999s ease-in-out 0s;\n}\n\n.custom-textarea > div:hover {\n  background-color: transparent !important;\n}\n\n.custom-textarea > div {\n  background-color: transparent !important;\n}\n\n.custom-textarea > div > label {\n  color: #ffffff !important;\n}\n\n.custom-textarea > div[data-focus=\"true\"] > label {\n  color: #52525b !important;\n}\n\n.custom-textarea > div > div > textarea {\n  color: #ffffff !important;\n}\n\n.input:-webkit-autofill {\n  font-size: 1rem;\n  background-color: transparent !important;\n}\n\n.autofill {\n  transform: translateY(-1rem);\n  /* Adjust to ensure placeholder doesn't overlap */\n  color: black;\n  /* Or any color that makes it readable */\n}\n\n.customMultiSelect:where(\n    .css-dev-only-do-not-override-ccdg5a\n  ).ant-select-outlined:not(.ant-select-customize-input)\n  .ant-select-selector {\n  border: none !important;\n}\n\n.customMultiSelect.ant-select-focused:where(\n    .css-dev-only-do-not-override-ccdg5a\n  ).ant-select-outlined:not(.ant-select-disabled):not(\n    .ant-select-customize-input\n  ):not(.ant-pagination-size-changer)\n  .ant-select-selector {\n  box-shadow: none !important;\n}\n\n.customMultiSelect:where(.css-dev-only-do-not-override-ccdg5a).ant-select\n  .ant-select-selection-placeholder {\n  color: black !important;\n}\n\n.dds_Dashboard .bg-default-100 {\n  background: #fff;\n  box-shadow: none;\n}\n\n.dds_Dashboard_dark .bg-default-100 {\n  background: #000;\n  box-shadow: none;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  position: relative !important;\n  width: fit-content !important;\n  display: inline-block !important;\n  color: black !important;\n  margin-left: 10px !important;\n  margin-top: 8px !important;\n  height: auto !important;\n  right: auto !important;\n  left: auto !important;\n  top: -45px !important;\n}\n\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-size: 20px !important;\n}\n\n.swiper-pagination {\n  float: left !important;\n  margin-left: 20px !important;\n  width: fit-content !important;\n  font-size: 20px !important;\n  margin-top: 10px !important;\n  position: relative !important;\n  display: inline-block !important;\n  top: -50px !important;\n  left: auto !important;\n  right: auto !important;\n}\n\n.force-scrollbar {\n  overflow-y: scroll !important;\n  height: calc(130vh - 150px) !important;\n  /* Adjust height as needed */\n}\n\n.force-scrollbar::-webkit-scrollbar {\n  width: 2px;\n}\n\n.force-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #777;\n  border-radius: 10px;\n}\n\n.progressbar {\n  background-color: #eee;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;\n  border-radius: 20px;\n  overflow: hidden;\n  height: 10px;\n  width: 100%;\n}\n\n.progress {\n  animation: progress 2s infinite linear;\n}\n\n.left-right {\n  transform-origin: 0% 50%;\n}\n\n@keyframes progress {\n  0% {\n    transform: translateX(0) scaleX(0);\n  }\n\n  25% {\n    transform: translateX(0) scaleX(0.4);\n  }\n\n  50% {\n    transform: translateX(100%) scaleX(0.5);\n  }\n\n  75% {\n    transform: translateX(100%) scaleX(-0.4);\n  }\n\n  100% {\n    transform: translateX(0) scaleX(0);\n  }\n}\n\n.search_select_field_dark\n  :where(.css-dev-only-do-not-override-ccdg5a).ant-select\n  .ant-select-selection-placeholder {\n  color: #e1e1e1;\n}\n\n.search_select_field_dark\n  :where(.css-dev-only-do-not-override-ccdg5a).ant-select-multiple\n  .ant-select-selection-overflow\n  .ant-select-selection-item-content {\n  color: white;\n}\n\n.search_select_field_dark\n  :where(.css-dev-only-do-not-override-ccdg5a).ant-select-multiple\n  .ant-select-selection-overflow\n  .ant-select-selection-item-remove {\n  color: white;\n}\n\n.custom_dark_multi:where(\n    .css-dev-only-do-not-override-ccdg5a\n  ).ant-select-outlined:not(.ant-select-customize-input)\n  .ant-select-selector {\n  background: black;\n}\n\n.custom_dark_multi:where(.css-dev-only-do-not-override-ccdg5a).ant-select\n  .ant-select-selection-placeholder {\n  color: white;\n}\n\n.draggable_dark_theme:where(\n    .css-dev-only-do-not-override-ccdg5a\n  ).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th {\n  color: white;\n  background: #424242;\n}\n\n.ant-select-focused:where(\n    .css-dev-only-do-not-override-ccdg5a\n  ).ant-select-outlined:not(.ant-select-disabled):not(\n    .ant-select-customize-input\n  ):not(.ant-pagination-size-changer)\n  .ant-select-selector {\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(\n    .ant-select-customize-input\n  )\n  .ant-select-selector {\n  border: none !important;\n}\n\n:where(.css-dev-only-do-not-override-ccdg5a).ant-select-outlined:not(\n    .ant-select-disabled\n  ):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover\n  .ant-select-selector {\n  border-color: transparent !important;\n}\n\n.search_select_field_dark\n  :where(.css-dev-only-do-not-override-142vneq).ant-select\n  .ant-select-selection-placeholder {\n  color: rgb(185, 185, 185);\n}\n\n.search_select_field_dark\n  :where(.css-1kf000u).ant-select\n  .ant-select-selection-placeholder {\n  color: rgb(185, 185, 185);\n}\n\n.search_select_field_dark .ant-select-selection-placeholder {\n  color: rgb(185, 185, 185) !important;\n}\n\n.group[data-has-helper=\"true\"] .group-data-\\[has-helper\\=true\\]\\:flex {\n  display: none;\n}\n\n/*Hold Multiline for multi select*/\n.customMultiSelect .ant-select-selector {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  align-items: center;\n  height: auto !important;\n  padding: 4px 8px;\n}\n\n.customMultiSelect .ant-select-selection-overflow {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.customMultiSelect .ant-select-selection-item {\n  white-space: nowrap;\n  margin-right: 8px;\n}\n\n.customMultiSelect .ant-select-selector::-webkit-scrollbar {\n  height: 4px;\n  display: none;\n}\n\n.customMultiSelect .ant-select-selector::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 2px;\n}\n\n.customMultiSelect .ant-select-selector:hover::-webkit-scrollbar {\n  display: block;\n}\n\n.customMultiSelect .ant-select-selector::-webkit-scrollbar-thumb:hover {\n  background-color: #aaa;\n}\n\n.ant-select-selector {\n  border-radius: 0px !important;\n  border: 0px !important;\n}\n\n.ant-select-selection-wrap {\n  align-self: center !important;\n}\n\n.custom_dark_multi .ant-select-selector {\n  background: black !important;\n}\n\n.custom_dark_multi .ant-select-selection-item {\n  background: gray !important;\n}\n\n.custom_dark_multi .ant-select-selection-placeholder {\n  color: gray !important ;\n}\n\n/* Fix for dropdown overlap in expanded rows */\n.ant-table-expanded-row > td {\n  position: relative;\n  z-index: 10;\n}\n\n.ant-table-expanded-row-fixed {\n  position: relative;\n  z-index: 11;\n}\n\n/* Ensure dropdowns in expanded rows appear above other content */\n.ant-select-dropdown,\n.ant-dropdown {\n  z-index: 9999 !important;\n}\n\n/* Fix for table row expansion */\n.ant-table-tbody > tr.ant-table-expanded-row > td {\n  padding: 0 !important;\n}\n\n.ant-table-expanded-row .ant-select {\n  position: relative;\n}\n\n/* Ensure proper stacking context for expanded content */\n.expanded-row-content {\n  position: relative;\n  z-index: 20;\n  background: white;\n  // padding: 16px;\n  padding-bottom: 150px !important;\n}\n\n/* Dark theme support */\n.draggable_dark_theme .expanded-row-content {\n  background: #1f1f1f;\n}\n\n/* Prevent overflow issues */\n.card-board {\n  position: relative;\n  overflow: false !important;\n}\n\n.draggable-table-container {\n  position: relative;\n}\n",".Login_left_pannel {\n  background-image: url(\"../images/login_left_panel_background1.jpg\");\n  color: white;\n  background-position: center; /* Center the image */\n  background-repeat: no-repeat; /* Do not repeat the image */\n  background-size: cover; /* Resize the background image to cover the entire container */\n  background-blend-mode: overlay;\n  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.75);\n}\n\n.login_left_panel_initial {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding-left: 20px;\n}\n\n.login_left_panel_internal_box {\n  width: calc(100% - 60px);\n}\n\n.logo_and_text {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  flex-direction: row;\n  gap: 24px;\n  width: max-content;\n  margin-bottom: 44px;\n\n  img {\n    width: 80px;\n    height: 80px;\n  }\n  .text {\n    img {\n      width: 280px;\n      height: 80px;\n    }\n  }\n}\n\n.content_below_logo {\n  .content_headingText {\n    width: max-content;\n    h1 {\n      font-size: 46px;\n      line-height: 52px;\n    }\n    h2 {\n      font-size: 46px;\n      line-height: 60px;\n      background: linear-gradient(to right, #10d6fe 0%, #0073ee 100%);\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  }\n  .content_supporting_text {\n    color: #93a2b3;\n    font-size: 20px !important;\n    line-height: 28px;\n    margin-top: 12px;\n    margin-bottom: 42px;\n    width: 450px;\n  }\n  .card_login {\n    background-color: #111f2c;\n    border-radius: 8px;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);\n    width: 384px;\n    padding: 20px 20px;\n    .card_header {\n      font-size: 28px;\n      margin-bottom: 16px;\n      line-height: 100%;\n      font-weight: 600;\n    }\n    .card_text {\n      font-size: 18px;\n      line-height: 24px;\n      margin-bottom: 24px;\n      color: #93a2b3;\n    }\n    button {\n      border-radius: 4px;\n      background-color: #e07900;\n      padding: 8px 16px;\n    }\n  }\n\n  .card_right_section {\n    padding-left: 24px;\n    h1 {\n      font-size: 24px;\n      line-height: 100%;\n    }\n    p {\n      font-size: 16px;\n      margin-top: 8px;\n      line-height: 20px;\n      color: #93a2b3;\n    }\n  }\n  .bottom_section {\n    color: #93a2b3;\n    font-size: 20px !important;\n    line-height: 28px;\n    margin-top: 52px;\n  }\n}\n\n.heading{\n  font-family: Graphic !important;\n}\n\n.supporting_text{\n  font-family: 'Sora', sans-serif !important;\n}\n\n.user-profile-image {\n  .upload-button {\n    width: 100px;\n    margin-top: 10px;\n  }\n}\n","@media (max-width: 1680px) {\n  .logo_and_text {\n    gap: 20px;\n\n    img {\n      width: 70px;\n      height: 70px;\n    }\n\n    .text {\n      img {\n        width: 250px;\n        height: 60px;\n      }\n    }\n  }\n\n  .content_below_logo {\n    .content_headingText {\n      h1 {\n        font-size: 32px;\n        line-height: 40px;\n      }\n\n      h2 {\n        font-size: 32px;\n        line-height: 40px;\n      }\n    }\n\n    .card_login {\n      width: 364px;\n      padding: 16px 16px;\n\n      .card_header {\n        font-size: 22px;\n        margin-bottom: 12px;\n      }\n\n      .card_text {\n        font-size: 16px;\n        line-height: 20px;\n        margin-bottom: 20px;\n      }\n\n      button {\n        padding: 6px 12px;\n      }\n    }\n\n    .card_right_section {\n      h1 {\n        font-size: 16px;\n      }\n\n      p {\n        font-size: 12px;\n        margin-top: 6px;\n        line-height: 16px;\n      }\n    }\n\n    .bottom_section {\n      font-size: 16px !important;\n      line-height: 24px;\n      margin-top: 32px;\n    }\n  }\n\n  .w-880 {\n    width: 880px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .w-880 {\n    width: 880px;\n  }\n}\n\n@media (max-width: 1365px) {\n\n  //MAC air\n  .logo_and_text {\n    gap: 20px;\n\n    img {\n      width: 70px;\n      height: 70px;\n    }\n\n    .text {\n      img {\n        width: 250px;\n        height: 60px;\n      }\n    }\n  }\n\n  .content_below_logo {\n    .content_headingText {\n      h1 {\n        font-size: 32px;\n        line-height: 40px;\n      }\n\n      h2 {\n        font-size: 32px;\n        line-height: 40px;\n      }\n    }\n\n    .card_login {\n      width: 364px;\n      padding: 16px 16px;\n\n      .card_header {\n        font-size: 22px;\n        margin-bottom: 12px;\n      }\n\n      .card_text {\n        font-size: 16px;\n        line-height: 20px;\n        margin-bottom: 20px;\n      }\n\n      button {\n        padding: 6px 12px;\n      }\n    }\n\n    .card_right_section {\n      h1 {\n        font-size: 16px;\n      }\n\n      p {\n        font-size: 12px;\n        margin-top: 6px;\n        line-height: 16px;\n      }\n    }\n\n    .bottom_section {\n      font-size: 16px !important;\n      line-height: 24px;\n      margin-top: 32px;\n    }\n  }\n\n  .w-880 {\n    width: 880px;\n  }\n}\n\n@media (max-width: 1279px) {\n  .w-880 {\n    width: 880px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .w-880 {\n    width: 780px;\n  }\n  .dashboard_card_main {\n    width: 100%;\n    height: 100%;\n  }\n\n  .card_title {\n    font-size: 21px;\n  }\n\n  .card_description {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1023px) {\n  .w-880 {\n    width: 600px;\n  }\n\n  .login_left_panel_initial {\n    padding: 5%;\n  }\n\n  .login_left_panel_internal_box {\n    width: calc(100%);\n  }\n\n  .logo_and_text {\n    gap: 20px;\n    margin-bottom: 10px;\n  }\n\n\n}\n\n@media (max-width: 642px) {\n\n  .map_toggle_button {\n    width: 100%;\n\n    .single_button {\n      width: 100%;\n    }\n  }\n\n  .border-right-only {\n    border-right: 0px;\n  }\n\n  .image-input-info {\n    width: 100%;\n  }\n\n  .csvButtonRepoting {\n    width: 100%;\n  }\n\n  .selectColumnsButton {\n    width: 100%;\n  }\n\n  .w-siderbar {\n    width: 55px;\n  }\n\n  .w-880 {\n    width: 600px;\n  }\n\n  .dashboard_card_inner_right {\n    padding: 0px 0px 0px 10px;\n  }\n\n  .card_title {\n    font-size: 20px;\n  }\n\n  .card_description {\n    font-size: 12px;\n  }\n\n  .content_below_logo {\n    .content_headingText {\n      h1 {\n        font-size: 24px;\n        line-height: 28px;\n      }\n\n      h2 {\n        font-size: 24px;\n        line-height: 28px;\n      }\n    }\n\n    .content_supporting_text {\n      font-size: 16px !important;\n      line-height: 20px;\n      margin-top: 10px;\n      margin-bottom: 20px;\n      width: 90%;\n    }\n\n    .card_login {\n      width: 364px;\n      padding: 16px 16px;\n\n      .card_header {\n        font-size: 18px;\n        margin-bottom: 10px;\n      }\n\n      .card_text {\n        font-size: 14px;\n        line-height: 18px;\n      }\n\n      button {\n        font-size: 14px;\n      }\n    }\n\n    .card_right_section {\n      h1 {\n        font-size: 14px;\n      }\n\n      p {\n        font-size: 10px;\n        line-height: 14px;\n      }\n    }\n\n    .bottom_section {\n      font-size: 10px !important;\n      line-height: 12px;\n      margin-top: 24px;\n    }\n  }\n\n}\n\n@media (max-width: 440px) {\n  .w-880 {\n    width: 400px;\n  }\n}\n\n@media (max-width: 380px) {\n  .w-880 {\n    width: 880px;\n  }\n}",".filterbar {\n  display: block;\n\n  .filterbar_inner {\n    margin-top: 10px;\n  }\n\n  .header_searchable {\n    width: 150px;\n    min-width: 150px;\n  }\n}\n\n.dashboard_header_main {\n  .top_header_filters {\n    padding: 10px 0;\n    justify-content: right;\n  }\n}\n\n.search_select_field,\n.search_datepicker_field {\n  display: flex;\n  align-items: center;\n  border-right: 1px solid #E6E6E6;\n\n  .search_select_calander_icon {\n    img {\n      min-width: 18px;\n    }\n  }\n\n  .header_searchable,\n  .header_datepicker {\n    min-width: 120px;\n    text-align: center;\n\n    &.border-gray-500 {\n      border-color: #d1d1d1;\n    }\n\n    .ant-select-selector,\n    .ant-picker {\n      font-family: \"Graphik\", sans-serif !important;\n      border: none !important;\n      background-color: transparent !important;\n\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n\n      .ant-select-selection-item,\n      .ant-picker-input>input {\n        font-size: 18px !important;\n        font-weight: 500;\n        margin-right: 5px;\n        background-color: transparent !important;\n        color: #33383f;\n\n        &:focus {\n          outline: none;\n        }\n      }\n\n      .ant-select-selection-placeholder {\n        font-size: 18px !important;\n      }\n    }\n\n    .ant-select-arrow {\n      .anticon {\n        svg {\n          fill: #9d9d9d;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n\n.search_select_field_dark,\n.search_datepicker_field {\n  display: flex;\n  align-items: center;\n  border-right: 1px solid #ffffff73;\n\n  .search_select_calander_icon {\n    img {\n      min-width: 18px;\n    }\n  }\n\n  .header_searchable,\n  .header_datepicker {\n    min-width: 120px;\n    text-align: center;\n\n    &.border-gray-500 {\n      border-color: #d1d1d1;\n    }\n\n    .ant-select-selector,\n    .ant-picker {\n      font-family: \"Graphik\", sans-serif !important;\n      border: none !important;\n      background-color: transparent !important;\n\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n\n      .ant-select-selection-item,\n      .ant-picker-input>input {\n        font-size: 18px !important;\n        font-weight: 500;\n        margin-right: 5px;\n        background-color: transparent !important;\n        color: #ffffff;\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    .ant-select-arrow {\n      .anticon {\n        svg {\n          fill: #9d9d9d;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n\n.my-select .ant-select-selection-overflow {\n  flex-wrap: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.my-select .ant-select-selection-overflow-item {\n  flex-shrink: 0;\n}\n\n.apply_filter_button {\n  height: 40px;\n  background-color: #0073EE;\n  padding: 10px 12px;\n  color: #FFFFFF;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 500;\n  border-radius: 8px;\n  margin-left: 8px;\n\n}\n\n.isDisabled {\n  background-color: #D4D4D4;\n  cursor: not-allowed;\n}\n\n.apply_filter_button:active {\n  background-color: #005bb5;\n  /* Darker shade for the click effect */\n  transform: scale(0.98);\n  /* Slightly shrink the button */\n}\n\n.cancle_filter_button {\n  height: 40px;\n  padding: 10px 12px;\n  color: #1D242E;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 500;\n  border-radius: 8px;\n  border: 1px solid #E5E9EB;\n}\n\n.dark_btn .cancle_filter_button {\n  height: 40px;\n  padding: 10px 12px;\n  color: #ffffff;\n  font-family: \"Graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 100%;\n  font-weight: 500;\n  border-radius: 8px;\n  border: 1px solid #E5E9EB;\n}\n\n.cancle_filter_button:active {\n  background-color: #F0F0F0;\n  /* Slightly darker background for the click effect */\n  border-color: #C0C0C0;\n  /* Darker border for the click effect */\n  transform: scale(0.98);\n  /* Slightly shrink the button */\n}\n\n:where(.css-dev-only-do-not-override-2rgkd4).ant-picker {\n  box-sizing: border-box;\n  margin: 0px 10px;\n  padding: 4px 11px 4px;\n  color: rgb(51, 56, 63) !important;\n  font-size: 12px !important;\n  line-height: 1;\n  list-style: none;\n  font-family: \"Graphik\", sans-serif !important;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background: transparent !important;\n  border-radius: 6px;\n  transition: border 0.2s, box-shadow 0.2s;\n  width: 221px !important;\n}\n\n\n// .multi_select_field.ant-select-selector {\n//   outline: none;\n//   color: white;\n//   border: none !important;\n//   padding: 8px 0px !important;\n//   padding-left: 5px !important;\n// }\n\n// .multi_select_field.ant-select-arrow,\n// .multi_select_field.ant-select-clear {\n//   color: white !important;\n// }\n\n// .multi_select_field.ant-select-selection-item {\n//   background-color: #0073ee !important;\n// }\n\n// .multi_select_field.ant-select-selection-item-remove {\n//   color: white !important;\n// }\n\n// .multi_select_field.ant-select-selection-placeholder {\n//   color: #9e9e9e !important;\n// }\n\n// .multi_select_field.ant-pagination-options-size-changer .ant-select-selector {\n//   background-color: white !important;\n// }\n\n// .multi_select_field.ant-pagination-options-size-changer\n//   .ant-select-selector\n//   .ant-select-selection-item {\n//   background-color: white !important;\n// }\n\n// multi_select_field.ant-select-selection-placeholder {\n//   color: #999999 !important;\n//   font-family: \"Sora\", sans-serif !important;\n//   font-size: 16px !important;\n// }\n\n// .multi_select_field.activity-mddl .ant-select-selector {\n//   background-color: white !important;\n//   outline: none;\n//   color: black;\n//   border: none !important;\n//   padding: 0px 0px !important;\n//   padding-left: 0px !important;\n//   outline: none !important;\n// }\n\n// .multi_select_field.multi_select_field .ant-select-focused {\n//   outline: none !important;\n// }\n\n\n.crossClass .ant-select-clear {\n  top: 35%;\n  right: 20%;\n  font-size: 18px;\n  opacity: 1;\n}\n\n.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker-outlined {\n  background: rgb(103, 103, 103);\n  border-color: black;\n}\n\n.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker {\n  color: white;\n}\n\n.search_date_field_dark :where(.css-dev-only-do-not-override-ccdg5a).ant-picker .ant-picker-input>input::placeholder {\n  color: #e3e3e3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
